import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
var SIcon_SIconType = /*#__PURE__*/ function(SIconType) {
    SIconType["ArrowRight"] = "arrow-right";
    SIconType["ChevronRight"] = "chevron-right";
    SIconType["ChevronRightLight"] = "chevron-right-light";
    SIconType["Debug"] = "debug";
    SIconType["Clock"] = "clock";
    SIconType["Back"] = "back";
    SIconType["Spinner"] = "spinner";
    SIconType["Android"] = "android";
    SIconType["Refresh"] = "refresh";
    SIconType["Users"] = "users";
    SIconType["Purchasers"] = "purchasers";
    SIconType["Apple"] = "apple";
    SIconType["Discord"] = "discord";
    SIconType["Device"] = "device";
    SIconType["UserProperties"] = "user-properties";
    SIconType["Bolt"] = "bolt";
    SIconType["Pin"] = "pin";
    SIconType["Chart"] = "chart";
    SIconType["Info"] = "info";
    SIconType["ChevronDown"] = "chevron-down";
    SIconType["ChevronDownSkinny"] = "chevron-down-skinny";
    SIconType["X"] = "x";
    SIconType["Calendar"] = "calendar";
    SIconType["User"] = "user";
    SIconType["Check"] = "check";
    SIconType["Up"] = "up";
    SIconType["Paywall"] = "paywall";
    SIconType["Session"] = "session";
    SIconType["PaywallConversion"] = "paywall-conversion";
    SIconType["PaywallClose"] = "paywall-close";
    SIconType["PaywallOpen"] = "paywall-open";
    SIconType["NoMatch"] = "no-match";
    SIconType["Cancel"] = "cancel";
    SIconType["DollarSign"] = "dollar-sign";
    SIconType["Checkout"] = "checkout";
    SIconType["Search"] = "search";
    SIconType["Logo"] = "logo";
    SIconType["LogoFull"] = "logo-full";
    SIconType["LogoColor"] = "logo-color";
    SIconType["Timer"] = "timer";
    SIconType["Cloud"] = "cloud";
    SIconType["RevenueCat"] = "revenue-cat";
    SIconType["Bag"] = "bag";
    SIconType["List"] = "list";
    SIconType["Enter"] = "enter";
    SIconType["Integration"] = "integration";
    SIconType["Copy"] = "copy";
    SIconType["Star"] = "star";
    SIconType["Trash"] = "trash";
    SIconType["Menu"] = "menu";
    SIconType["Play"] = "play";
    SIconType["Pause"] = "pause";
    SIconType["TrashBox"] = "trash-box";
    SIconType["Pdf"] = "pdf";
    SIconType["Csv"] = "csv";
    SIconType["File"] = "file";
    SIconType["Download"] = "download";
    SIconType["DownloadAlt"] = "download-alt";
    SIconType["Open"] = "open";
    SIconType["Notification"] = "notification";
    SIconType["Megaphone"] = "megaphone";
    SIconType["Crown"] = "crown";
    SIconType["Archive"] = "archive";
    SIconType["EyeOpen"] = "eye-open";
    SIconType["EyeClose"] = "eye-close";
    SIconType["Pencil"] = "pencil";
    SIconType["Product"] = "product";
    SIconType["MoreInfo"] = "more-info";
    SIconType["SubscriptionRevenue"] = "subscription-revenue";
    SIconType["GooglePlay"] = "google-play";
    SIconType["Forward"] = "forward";
    SIconType["InfoFilled"] = "info-filled";
    SIconType["Layout"] = "layout";
    SIconType["Language"] = "language";
    SIconType["Survey"] = "survey";
    SIconType["PainBrush"] = "pain-brush";
    SIconType["Settings"] = "settings";
    SIconType["Code"] = "code";
    SIconType["Confused"] = "confused";
    SIconType["Undo"] = "undo";
    SIconType["Redo"] = "redo";
    SIconType["TriangleRight"] = "triangle-right";
    SIconType["PlayLarge"] = "play-large";
    SIconType["NodeImage"] = "node-image";
    SIconType["NodeDiv"] = "node-div";
    SIconType["NodeText"] = "node-text";
    SIconType["NodeVideo"] = "node-video";
    SIconType["Plus"] = "plus";
    SIconType["NodeCollapseAll"] = "node-collapse-all";
    SIconType["NodeExpandAll"] = "node-expand-all";
    SIconType["NodeAnimation"] = "node-animation";
    SIconType["NodeZStack"] = "node-z-stack";
    SIconType["NodeStack"] = "node-stack";
    SIconType["NodeNavigation"] = "node-navigation";
    SIconType["CheckThick"] = "check-thick";
    SIconType["Kebab"] = "kebab";
    SIconType["Bookmark"] = "bookmark";
    SIconType["NodeNumber"] = "node-number";
    SIconType["CornersAll"] = "corners-all";
    SIconType["CornersIndividual"] = "corners-individual";
    SIconType["PropertiesLinked"] = "properties-linked";
    SIconType["PropertiesUnlinked"] = "properties-unlinked";
    SIconType["Italic"] = "italic";
    SIconType["ItalicNot"] = "italic-not";
    SIconType["Youtube"] = "youtube";
    SIconType["Fixed"] = "fixed";
    SIconType["ShadowInside"] = "shadow-inside";
    SIconType["ShadowOutside"] = "shadow-outside";
    SIconType["Split"] = "split";
    SIconType["Upload"] = "upload";
    SIconType["ArrowUpRight"] = "arrow-up-right";
    SIconType["WarningTriangle"] = "warning-triangle";
    SIconType["CampaignUsers"] = "campaign-users";
    SIconType["CampaignDevice"] = "campaign-device";
    SIconType["CampaignParams"] = "campaign-params";
    SIconType["CampaignTimeSince"] = "campaign-time-since";
    SIconType["Funnel"] = "funnel";
    SIconType["FunnelLines"] = "funnel-lines";
    SIconType["Trial"] = "trial";
    SIconType["Subscription"] = "subscription";
    SIconType["CheckoutConversion"] = "checkout-conversion";
    SIconType["CreditCard"] = "credit-card";
    SIconType["Wallet"] = "wallet";
    SIconType["PaywalledUser"] = "paywalled-user";
    SIconType["PaywallRate"] = "paywall-rate";
    SIconType["PaywallConversionRate"] = "paywall-conversion-rate";
    SIconType["Proceeds"] = "proceeds";
    SIconType["PlusThick"] = "plus-thick";
    SIconType["BoltOff"] = "bolt-off";
    SIconType["Globe"] = "globe";
    SIconType["Stripe"] = "stripe";
    SIconType["PlusCircle"] = "plus-circle";
    SIconType["NodeDrawer"] = "node-drawer";
    SIconType["Edit"] = "edit";
    SIconType["MoreVertical"] = "more-vertical";
    SIconType["Link"] = "link";
    SIconType["LinkOff"] = "link-off";
    SIconType["Gift"] = "gift";
    SIconType["FolderBookmark"] = "folder-bookmark";
    SIconType["ListSparkle"] = "list-sparkle";
    SIconType["Markdown"] = "markdown";
    return SIconType;
}({});
const SIcon = ({ width: w, height: h, size: s = 24, color = "currentColor", type, className })=>{
    const size = "number" == typeof s ? s : "sm" === s ? 16 : "md" === s ? 24 : 36;
    const width = `${w || size}`;
    const height = `${h || size}`;
    switch(type){
        case "markdown":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "none",
                className: className,
                height: height,
                width: width,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M6.75 14.25V9.75L9 12L11.25 9.75V14.25M15.75 9.75V14.25M15.75 14.25L14 12.5M15.75 14.25L17.5 12.5M4.75 19.25H19.25C20.3546 19.25 21.25 18.3546 21.25 17.25V6.75C21.25 5.64543 20.3546 4.75 19.25 4.75H4.75C3.64543 4.75 2.75 5.64543 2.75 6.75V17.25C2.75 18.3546 3.64543 19.25 4.75 19.25Z",
                    stroke: color,
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            });
        case "list-sparkle":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                height: height,
                width: width,
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M17 10L15.5 13.5L12 15L15.5 16.5L17 20L18.5 16.5L22 15L18.5 13.5L17 10Z",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M4 18H7",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M4 12H9",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M4 6H20",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            });
        case "folder-bookmark":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                height: height,
                width: width,
                fill: "none",
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M10.25 19.25H19.25C20.3546 19.25 21.25 18.3546 21.25 17.25V8.75C21.25 7.64543 20.3546 6.75 19.25 6.75H13.0704C12.4017 6.75 11.7772 6.4158 11.4063 5.8594L10.5937 4.6406C10.2228 4.0842 9.59834 3.75 8.92963 3.75H4.75C3.64543 3.75 2.75 4.64543 2.75 5.75V10.75M6.25 13.75H2.75C2.19772 13.75 1.75 14.1977 1.75 14.75V20.25L4.5 18.75L7.25 20.25V14.75C7.25 14.1977 6.80228 13.75 6.25 13.75Z",
                    stroke: color,
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case "gift":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                height: height,
                width: width,
                fill: "none",
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M19 11.7324V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V11.7324M19 11.7324V11.5M19 11.7324C19.5978 11.3866 20 10.7403 20 10C20 8.89543 19.1046 8 18 8H6C4.89543 8 4 8.89543 4 10C4 10.7403 4.4022 11.3866 5 11.7324M19 11.7324C18.7058 11.9026 18.3643 12 18 12H6C5.63571 12 5.29417 11.9026 5 11.7324M5 11.7324V11.5M12 8V6.33333M12 8H10.3333C8.49238 8 7 6.50762 7 4.66667C7 3.74619 7.74619 3 8.66667 3C10.5076 3 12 4.49238 12 6.33333M12 8H13.6667C15.5076 8 17 6.50762 17 4.66667C17 3.74619 16.2538 3 15.3333 3C13.4924 3 12 4.49238 12 6.33333M12 8V20",
                    stroke: color,
                    strokeWidth: "2"
                })
            });
        case "link":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                height: height,
                width: width,
                className: className,
                fill: "none",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M10 5.5L10.7514 4.75837C13.0959 2.41387 16.8971 2.41388 19.2416 4.75837C21.5861 7.10287 21.5861 10.9041 19.2416 13.2486L18.5 14M5.5 10L4.75837 10.7514C2.41387 13.0959 2.41388 16.8971 4.75838 19.2416C7.10287 21.5861 10.9041 21.5861 13.2486 19.2416L14 18.5M10 14L14 10",
                    stroke: color,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            });
        case "link-off":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                height: height,
                width: width,
                fill: "none",
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M10 5.5L10.7514 4.75837C13.0959 2.41387 16.8971 2.41388 19.2416 4.75837C21.5861 7.10287 21.5861 10.9041 19.2416 13.2486L18.5 14M5.5 10L4.75837 10.7514C2.41387 13.0959 2.41388 16.8971 4.75838 19.2416C7.10287 21.5861 10.9041 21.5861 13.2486 19.2416L14 18.5M10 14L9 15M14 10L15 9",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M3 3L21 21",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeWidth: "2"
                    })
                ]
            });
        case "discord":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                role: "img",
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                fill: "none",
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fill: "currentColor",
                    d: "M19.73 4.87a18.2 18.2 0 0 0-4.6-1.44c-.21.4-.4.8-.58 1.21-1.69-.25-3.4-.25-5.1 0-.18-.41-.37-.82-.59-1.2-1.6.27-3.14.75-4.6 1.43A19.04 19.04 0 0 0 .96 17.7a18.43 18.43 0 0 0 5.63 2.87c.46-.62.86-1.28 1.2-1.98-.65-.25-1.29-.55-1.9-.92.17-.12.32-.24.47-.37 3.58 1.7 7.7 1.7 11.28 0l.46.37c-.6.36-1.25.67-1.9.92.35.7.75 1.35 1.2 1.98 2.03-.63 3.94-1.6 5.64-2.87.47-4.87-.78-9.09-3.3-12.83ZM8.3 15.12c-1.1 0-2-1.02-2-2.27 0-1.24.88-2.26 2-2.26s2.02 1.02 2 2.26c0 1.25-.89 2.27-2 2.27Zm7.4 0c-1.1 0-2-1.02-2-2.27 0-1.24.88-2.26 2-2.26s2.02 1.02 2 2.26c0 1.25-.88 2.27-2 2.27Z"
                })
            });
        case "more-vertical":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                height: height,
                width: width,
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 5.5C12.8284 5.5 13.5 4.82842 13.5 4C13.5 3.17158 12.8284 2.5 12 2.5C11.1716 2.5 10.5 3.17158 10.5 4C10.5 4.82842 11.1716 5.5 12 5.5Z",
                        fill: color,
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z",
                        fill: color,
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 21.5C12.8284 21.5 13.5 20.8284 13.5 20C13.5 19.1716 12.8284 18.5 12 18.5C11.1716 18.5 10.5 19.1716 10.5 20C10.5 20.8284 11.1716 21.5 12 21.5Z",
                        fill: color,
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            });
        case "edit":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M13.086,5.5L3.293,15.293c-.109,.11-.192,.244-.241,.391l-2,6c-.12,.359-.026,.756,.241,1.023,.19,.191,.446,.293,.707,.293,.105,0,.213-.017,.316-.051l6-2c.147-.049,.281-.132,.391-.242l9.793-9.793-5.414-5.414Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M22.414,4.172l-2.586-2.586c-.779-.78-2.049-.78-2.828,0l-2.5,2.5,5.414,5.414,2.5-2.5c.378-.378,.586-.88,.586-1.414s-.208-1.037-.586-1.414Z"
                        })
                    ]
                })
            });
        case "stripe":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M10.3805 7.76329C10.3805 6.93398 11.061 6.61488 12.1883 6.61488C13.8045 6.61488 15.8461 7.10415 17.4624 7.97607V2.97824C15.6973 2.27649 13.9534 2 12.1883 2C7.87103 2 5 4.25436 5 8.01869C5 13.8881 13.0813 12.9525 13.0813 15.4834C13.0813 16.4615 12.2308 16.7806 11.0398 16.7806C9.27469 16.7806 7.02034 16.0574 5.23387 15.0792V20.1407C7.21174 20.9914 9.21084 21.3528 11.0398 21.3528C15.4633 21.3528 18.5044 19.1625 18.5044 15.3557C18.4832 9.01817 10.3805 10.1452 10.3805 7.76329Z",
                    fill: "#635BFF"
                })
            });
        case "globe":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                fill: "none",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.17156 8.07011L6.85387 10.0833C7.50915 10.5752 8.44975 10.3548 8.81836 9.62306C8.99021 9.28194 9.30184 9.03235 9.67226 8.93916L11.8457 8.39241C12.5416 8.21734 13.0847 7.67348 13.2587 6.97732L14.126 3.50882M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.4252 15.9984L10.6023 14.7641C10.2853 14.2886 10.3486 13.6553 10.7535 13.2519C10.9966 13.0096 11.3322 12.8834 11.6748 12.9052L12.5015 12.958C12.8453 12.9799 13.1771 13.0927 13.463 13.2848L14.8342 14.2063C15.4406 14.6138 15.6501 15.4083 15.3233 16.0618C15.0772 16.554 14.5742 16.8649 14.0239 16.8649H13.0443C12.3937 16.8649 11.7861 16.5397 11.4252 15.9984Z",
                    stroke: color,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            });
        case "plus-circle":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12,12-5.373,12-12C23.981,5.381,18.619,.019,12,0Zm5,13h-4v4c0,.552-.448,1-1,1s-1-.448-1-1v-4H7c-.552,0-1-.448-1-1s.448-1,1-1h4V7c0-.552,.448-1,1-1s1,.448,1,1v4h4c.552,0,1,.448,1,1s-.448,1-1,1Z",
                        fill: color
                    })
                })
            });
        case "android":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M0,12H16a9.3,9.3,0,0,0-3.841-6.688l1.288-2.576a.5.5,0,1,0-.894-.447L11.3,4.805a7.146,7.146,0,0,0-6.59,0L3.447,2.289a.5.5,0,1,0-.894.447L3.841,5.312A9.3,9.3,0,0,0,0,12ZM11.5,8a1,1,0,1,1-1,1A1,1,0,0,1,11.5,8Zm-7,0a1,1,0,1,1-1,1A1,1,0,0,1,4.5,8Z",
                        fill: color
                    })
                })
            });
        case "chart":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M5.562,7.048l.459.367L6.4,6.553,9.4,8.8a1,1,0,0,0,1.432-.245l4-6a1,1,0,0,0-1.664-1.11L9.754,6.566,6.6,4.2a1,1,0,0,0-1.514.394L4.23,6.52A2.5,2.5,0,0,1,5.562,7.048Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M3.123,11.5H2.016l-.93,2.094a1,1,0,0,0,.508,1.32A.987.987,0,0,0,2,15a1,1,0,0,0,.915-.594l1.008-2.267Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M9,14a1,1,0,0,1-.625-.219L3.649,10H1A1,1,0,0,1,1,8H4a1,1,0,0,1,.625.219l4.457,3.566,4.4-2.642a1,1,0,0,1,1.03,1.714l-5,3A1,1,0,0,1,9,14Z"
                        })
                    ]
                })
            });
        case "arrow-right":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: "currentColor",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M10.707,2.293A1,1,0,0,0,9.293,3.707L12.586,7H1A1,1,0,0,0,1,9H12.586L9.293,12.293a1,1,0,1,0,1.414,1.414l5-5a1,1,0,0,0,0-1.414Z",
                        fill: "currentColor"
                    })
                })
            });
        case "proceeds":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 11 17",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M5.08587 16.3999C4.96735 16.3999 4.86661 16.3584 4.78365 16.2755C4.70068 16.2043 4.6592 16.1036 4.6592 15.9732V14.7288C3.80587 14.6458 3.07105 14.4384 2.45476 14.1066C1.85031 13.7747 1.38809 13.3718 1.06809 12.8977C0.759942 12.4118 0.594016 11.8962 0.570312 11.351C0.570312 11.2562 0.605868 11.1732 0.676979 11.1021C0.759942 11.0192 0.854757 10.9777 0.961424 10.9777H2.56142C2.70365 10.9777 2.81031 11.0073 2.88142 11.0666C2.96439 11.114 3.04142 11.1969 3.11253 11.3155C3.24291 11.7184 3.5155 12.0562 3.93031 12.3288C4.35698 12.6014 4.93772 12.7377 5.67254 12.7377C6.49031 12.7377 7.10661 12.6014 7.52142 12.3288C7.94809 12.0443 8.16142 11.6592 8.16142 11.1732C8.16142 10.8532 8.05476 10.5866 7.84142 10.3732C7.62809 10.1599 7.30216 9.9762 6.86365 9.82212C6.43698 9.6562 5.80291 9.46064 4.96142 9.23546C3.56291 8.90361 2.53772 8.46509 1.88587 7.9199C1.23402 7.37472 0.90809 6.59249 0.90809 5.57324C0.90809 4.64879 1.23994 3.86657 1.90365 3.22657C2.5792 2.58657 3.49772 2.19546 4.6592 2.05324V0.826569C4.6592 0.696198 4.70068 0.595457 4.78365 0.524346C4.86661 0.441384 4.96735 0.399902 5.08587 0.399902H6.18809C6.31846 0.399902 6.4192 0.441384 6.49031 0.524346C6.57328 0.595457 6.61476 0.696198 6.61476 0.826569V2.08879C7.38513 2.19546 8.0429 2.42657 8.58809 2.78212C9.14513 3.12583 9.56587 3.52879 9.85031 3.99101C10.1466 4.45324 10.3066 4.90361 10.3303 5.34212C10.3303 5.44879 10.2948 5.53768 10.2236 5.60879C10.1525 5.6799 10.0636 5.71546 9.95698 5.71546H8.26809C8.0192 5.71546 7.84735 5.60879 7.75254 5.39546C7.68142 5.0162 7.44439 4.70212 7.04142 4.45324C6.65031 4.19249 6.15846 4.06212 5.56587 4.06212C4.91402 4.06212 4.39846 4.18657 4.0192 4.43546C3.65179 4.68435 3.46809 5.04583 3.46809 5.5199C3.46809 5.8399 3.55698 6.10657 3.73476 6.3199C3.92439 6.53324 4.22068 6.72287 4.62365 6.88879C5.03846 7.05472 5.62513 7.23249 6.38365 7.42212C7.43846 7.65916 8.27402 7.92583 8.89031 8.22212C9.51846 8.51842 9.98068 8.89175 10.277 9.34212C10.5733 9.7925 10.7214 10.3673 10.7214 11.0666C10.7214 12.0977 10.3481 12.9332 9.60142 13.5732C8.86661 14.2132 7.87105 14.5984 6.61476 14.7288V15.9732C6.61476 16.1036 6.57328 16.2043 6.49031 16.2755C6.4192 16.3584 6.31846 16.3999 6.18809 16.3999H5.08587Z",
                    fill: color
                })
            });
        case "paywall-conversion-rate":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 12 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2 0C0.895416 0 0 0.895416 0 2V14C0 15.1046 0.895416 16 2 16H10C11.1046 16 12 15.1046 12 14V2C12 0.895416 11.1046 0 10 0H2ZM2.75 4.5C2.33578 4.5 2 4.83578 2 5.25C2 5.66422 2.33578 6 2.75 6H9.25C9.66422 6 10 5.66422 10 5.25C10 4.83578 9.66422 4.5 9.25 4.5H2.75ZM3 8.25C3 7.83578 3.33578 7.5 3.75 7.5H8.25C8.66422 7.5 9 7.83578 9 8.25C9 8.66422 8.66422 9 8.25 9H3.75C3.33578 9 3 8.66422 3 8.25ZM4.75 10.5C4.33578 10.5 4 10.8358 4 11.25C4 11.6642 4.33578 12 4.75 12H7.25C7.66422 12 8 11.6642 8 11.25C8 10.8358 7.66422 10.5 7.25 10.5H4.75Z",
                    fill: color
                })
            });
        case "paywall-rate":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                width: width,
                className: className,
                height: height,
                viewBox: "0 0 12 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0 2C0 0.895431 0.895431 0 2 0H10C11.1046 0 12 0.895431 12 2V14C12 15.1046 11.1046 16 10 16H2C0.895431 16 0 15.1046 0 14V2ZM1.5 3C1.5 2.44772 1.94772 2 2.5 2H9.5C10.0523 2 10.5 2.44772 10.5 3V13C10.5 13.5523 10.0523 14 9.5 14H2.5C1.94772 14 1.5 13.5523 1.5 13V3ZM3 10C2.72386 10 2.5 10.2239 2.5 10.5V12.5C2.5 12.7761 2.72386 13 3 13H9C9.27614 13 9.5 12.7761 9.5 12.5V10.5C9.5 10.2239 9.27614 10 9 10H3Z",
                    fill: color
                })
            });
        case "paywalled-user":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 12 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 2C0 0.895431 0.895431 0 2 0H10C11.1046 0 12 0.895431 12 2V14C12 15.1046 11.1046 16 10 16H2C0.895431 16 0 15.1046 0 14V2ZM2.95 13C2.7016 13 2.5 12.8133 2.5 12.5833C2.5 10.2858 3.5187 8.75 6 8.75C8.4813 8.75 9.5 10.2858 9.5 12.5833C9.5 12.8133 9.2984 13 9.05 13H2.95ZM6 7.5C7.38071 7.5 8.5 6.43668 8.5 5.125C8.5 3.81332 7.38071 2.75 6 2.75C4.61929 2.75 3.5 3.81332 3.5 5.125C3.5 6.43668 4.61929 7.5 6 7.5Z",
                    fill: color
                })
            });
        case "paywall-conversion":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "8",
                            cy: "8",
                            r: "3"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M3.7,2.387A1,1,0,0,0,2.286,2.4a8,8,0,0,0,0,11.2,1,1,0,1,0,1.428-1.4,6,6,0,0,1,0-8.4A1,1,0,0,0,3.7,2.387Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M13.714,2.4a1,1,0,1,0-1.428,1.4,6,6,0,0,1,0,8.4,1,1,0,0,0,1.428,1.4,8,8,0,0,0,0-11.2Z",
                            fill: color
                        })
                    ]
                })
            });
        case "wallet":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M10,0H1.5C0.7,0,0,0.7,0,1.5v0C0,2.3,0.7,3,1.5,3H10V0z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M15,5H0v9c0,1.1,0.9,2,2,2h13c0.6,0,1-0.4,1-1V6C16,5.4,15.6,5,15,5z M12.5,12c-0.8,0-1.5-0.7-1.5-1.5 S11.7,9,12.5,9S14,9.7,14,10.5S13.3,12,12.5,12z",
                            fill: color
                        })
                    ]
                })
            });
        case "credit-card":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                    })
                })
            });
        case "checkout-conversion":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M22,5h-1.586l-3.707-3.707c-0.391-0.391-1.023-0.391-1.414,0L13.5,3.086l-1.793-1.793 c-0.391-0.391-1.023-0.391-1.414,0L6.586,5H5.542L4.991,0.868C4.925,0.371,4.501,0,4,0H1v2h2.125l1.884,14.132 C5.075,16.629,5.499,17,6,17h14c0.477,0,0.887-0.336,0.98-0.804l2-10c0.059-0.294-0.017-0.599-0.207-0.83C22.583,5.134,22.3,5,22,5z M16,3.414L17.586,5h-2.172l-0.5-0.5L16,3.414z M11,3.414L12.586,5H9.414L11,3.414z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "6.5",
                            cy: "21.5",
                            r: "2.5"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "19.5",
                            cy: "21.5",
                            r: "2.5"
                        })
                    ]
                })
            });
        case "funnel-lines":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M9,15H7c-0.552,0-1-0.448-1-1v0c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v0 C10,14.552,9.552,15,9,15z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M11,11H5c-0.552,0-1-0.448-1-1v0c0-0.552,0.448-1,1-1h6c0.552,0,1,0.448,1,1v0C12,10.552,11.552,11,11,11z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M13,7H3C2.448,7,2,6.552,2,6v0c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1v0 C14,6.552,13.552,7,13,7z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M15,3H1C0.448,3,0,2.552,0,2v0c0-0.552,0.448-1,1-1h14c0.552,0,1,0.448,1,1v0C16,2.552,15.552,3,15,3z"
                        })
                    ]
                })
            });
        case "subscription":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M6.673,5.711a.5.5,0,0,0,.269-.837l-1.6-1.68a5.489,5.489,0,0,1,7.9,3.114,1,1,0,0,0,1.9-.616A7.489,7.489,0,0,0,3.924,1.713L2.436.154a.5.5,0,0,0-.849.235L.263,6.194a.5.5,0,0,0,.487.612A.478.478,0,0,0,.842,6.8Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M15.61,9.348a.493.493,0,0,0-.452-.145L9.327,10.289a.5.5,0,0,0-.269.837l1.6,1.68a5.489,5.489,0,0,1-7.9-3.114,1,1,0,0,0-1.9.616,7.489,7.489,0,0,0,11.214,3.979l1.488,1.559a.5.5,0,0,0,.495.136.5.5,0,0,0,.354-.371l1.324-5.805A.5.5,0,0,0,15.61,9.348Z"
                        })
                    ]
                })
            });
        case "trial":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M9.4,6.6c0.8,0.8,0.8,2,0,2.8c-0.8,0.8-2,0.8-2.8,0C5.8,8.6,1.6,1.6,1.6,1.6S8.6,5.8,9.4,6.6 z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M8,16c-4.4,0-8-3.6-8-8c0-0.6,0.4-1,1-1s1,0.4,1,1c0,3.3,2.7,6,6,6s6-2.7,6-6s-2.7-6-6-6C7.4,2,7,1.6,7,1 s0.4-1,1-1c4.4,0,8,3.6,8,8S12.4,16,8,16z"
                        })
                    ]
                })
            });
        case "funnel":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M22,0H2A1,1,0,0,0,1,1V4a1,1,0,0,0,.293.707L9,12.414V23a1,1,0,0,0,1.6.8l4-3A1,1,0,0,0,15,20V12.414l7.707-7.707A1,1,0,0,0,23,4V1A1,1,0,0,0,22,0Z",
                        fill: color
                    })
                })
            });
        case "clock":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M8,0a8,8,0,1,0,8,8A8.024,8.024,0,0,0,8,0ZM8,14a6,6,0,1,1,6-6A6.018,6.018,0,0,1,8,14Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M11.5,7H9V4.5a1,1,0,0,0-2,0V8A1,1,0,0,0,8,9h3.5a1,1,0,0,0,0-2Z"
                        })
                    ]
                })
            });
        case "campaign-time-since":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M10.589,21H4c-0.552,0-1-0.448-1-1V4c0-0.552,0.448-1,1-1h12c0.552,0,1,0.448,1,1v6.069 C17.328,10.028,17.661,10,18,10s0.672,0.028,1,0.069V3c0-1.654-1.346-3-3-3H4C2.346,0,1,1.346,1,3v18c0,1.654,1.346,3,3,3h8.726 C11.799,23.184,11.061,22.162,10.589,21z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M18,24c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S14.686,24,18,24z M17,14h2v3h3v2h-5V14 z"
                        })
                    ]
                })
            });
        case "campaign-users":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 12 12",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            cx: "6",
                            cy: "3",
                            r: "3",
                            "data-color": "color-2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M6,7C2.625,7,1,9.106,1,10.333V11a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1v-.667C11,9.106,9.375,7,6,7Z",
                            fill: color
                        })
                    ]
                })
            });
        case "campaign-device":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M12,0H4C2.897,0,2,0.897,2,2v12c0,1.103,0.897,2,2,2h8c1.103,0,2-0.897,2-2V2C14,0.897,13.103,0,12,0z M8,14 c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S8.552,14,8,14z M12,10H4V2h8V10z"
                    })
                })
            });
        case "campaign-params":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 12 12",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M11.954,4.291A.5.5,0,0,0,11.5,4H6.141L6.985.621A.5.5,0,0,0,6.121.175l-6,7A.5.5,0,0,0,.5,8H5.859l-.844,3.379a.5.5,0,0,0,.256.565A.49.49,0,0,0,5.5,12a.5.5,0,0,0,.379-.175l6-7A.5.5,0,0,0,11.954,4.291Z",
                        fill: color
                    })
                })
            });
        case "play-large":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 64 64",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M58.5,31.136l-48-28A1,1,0,0,0,9,4V60a1,1,0,0,0,1.5.864l48-28a1,1,0,0,0,0-1.728Z"
                    })
                })
            });
        case "chevron-down-skinny":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M9,23a1,1,0,0,1-.818-1.573L14.779,12l-6.6-9.427A1,1,0,0,1,9.819,1.427l7,10a1,1,0,0,1,0,1.146l-7,10A1,1,0,0,1,9,23Z",
                        fill: color
                    })
                })
            });
        case "warning-triangle":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M15.8,12.526,9.483.88A1.668,1.668,0,0,0,8.8.2,1.693,1.693,0,0,0,6.516.88L.2,12.526A1.678,1.678,0,0,0,1.686,15H14.314a1.7,1.7,0,0,0,.8-.2,1.673,1.673,0,0,0,.687-2.274ZM8,13a1,1,0,1,1,1-1A1,1,0,0,1,8,13ZM9,9.5a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,9.5v-4A.5.5,0,0,1,7.5,5h1a.5.5,0,0,1,.5.5Z"
                    })
                })
            });
        case "arrow-up-right":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                height: height,
                width: width,
                viewBox: "0 0 16 16",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M9.707,1.293A1,1,0,0,0,8.293,2.707L11.586,6H3A2,2,0,0,0,1,8v6a1,1,0,0,0,2,0V8h8.586L8.293,11.293a1,1,0,1,0,1.414,1.414l5-5a1,1,0,0,0,0-1.414Z"
                    })
                })
            });
        case "upload":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M14,10a1,1,0,0,0-1,1v2H3V11a1,1,0,0,0-2,0v2a2,2,0,0,0,2,2H13a2,2,0,0,0,2-2V11A1,1,0,0,0,14,10Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M4.707,6.707,7,4.414V10a1,1,0,0,0,2,0V4.414l2.293,2.293a1,1,0,0,0,1.414-1.414l-4-4a1,1,0,0,0-1.414,0l-4,4A1,1,0,0,0,4.707,6.707Z"
                        })
                    ]
                })
            });
        case "shadow-inside":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                        opacity: "0.1",
                        cx: "8",
                        cy: "8",
                        r: "8",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                        cx: "8",
                        cy: "8",
                        r: "4",
                        fill: color
                    })
                ]
            });
        case "shadow-outside":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                        opacity: "0.1",
                        cx: "8",
                        cy: "8",
                        r: "6",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
                        fill: color
                    })
                ]
            });
        case "fixed":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            cx: "8",
                            cy: "8",
                            r: "2",
                            "data-color": "color-2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "7",
                            width: "2",
                            height: "4",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "12",
                            y: "7",
                            width: "4",
                            height: "2",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "7",
                            y: "12",
                            width: "2",
                            height: "4",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            y: "7",
                            width: "4",
                            height: "2",
                            fill: color
                        })
                    ]
                })
            });
        case "pin":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M15.7,5.7l-5.4-5.4c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l0.6,0.6L2.7,6l-1-1c-0.4-0.4-1-0.4-1.4,0 s-0.4,1,0,1.4l1.5,1.5c0,0,0,0,0,0l2.4,2.4L0.6,14L2,15.4l3.7-3.7l4,4c0.5,0.5,1.2,0.2,1.4,0c0.4-0.4,0.4-1,0-1.4l-1-1l3.7-6.7 l0.6,0.6c0.6,0.6,1.2,0.2,1.4,0C16.1,6.8,16.1,6.1,15.7,5.7z M8.5,11.8L4.2,7.5l6.7-3.7l1.3,1.3L8.5,11.8z"
                    })
                })
            });
        case "eye-close":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M14.6,5.6l-8.2,8.2C6.9,13.9,7.5,14,8,14c3.6,0,6.4-3.1,7.6-4.9c0.5-0.7,0.5-1.6,0-2.3 C15.4,6.5,15,6.1,14.6,5.6z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M14.3,0.3L11.6,3C10.5,2.4,9.3,2,8,2C4.4,2,1.6,5.1,0.4,6.9c-0.5,0.7-0.5,1.6,0,2.2c0.5,0.8,1.4,1.8,2.4,2.7 l-2.5,2.5c-0.4,0.4-0.4,1,0,1.4C0.5,15.9,0.7,16,1,16s0.5-0.1,0.7-0.3l14-14c0.4-0.4,0.4-1,0-1.4S14.7-0.1,14.3,0.3z M5.3,9.3 C5.1,8.9,5,8.5,5,8c0-1.7,1.3-3,3-3c0.5,0,0.9,0.1,1.3,0.3L5.3,9.3z"
                        })
                    ]
                })
            });
        case "eye-open":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M8,14c3.6,0,6.4-3.1,7.6-4.9c0.5-0.7,0.5-1.6,0-2.3C14.4,5.1,11.6,2,8,2C4.4,2,1.6,5.1,0.4,6.9 c-0.5,0.7-0.5,1.6,0,2.2C1.6,10.9,4.4,14,8,14z M8,5c1.7,0,3,1.3,3,3s-1.3,3-3,3S5,9.7,5,8S6.3,5,8,5z"
                    })
                })
            });
        case "youtube":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: "0 0 146 33",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M45.5893 5.69901C45.324 4.73036 44.804 3.84717 44.0816 3.13788C43.3591 2.4286 42.4596 1.91813 41.4729 1.65759C37.8415 0.702271 23.2812 0.702271 23.2812 0.702271C23.2812 0.702271 8.7206 0.702271 5.08944 1.65759C4.10283 1.91815 3.20327 2.42864 2.48083 3.13791C1.75839 3.84719 1.23844 4.73037 0.973044 5.69901C0 9.26432 0 16.7023 0 16.7023C0 16.7023 0 24.1405 0.973044 27.7053C1.23842 28.6739 1.75836 29.5571 2.4808 30.2664C3.20324 30.9757 4.10282 31.4861 5.08944 31.7467C8.7206 32.7023 23.2812 32.7023 23.2812 32.7023C23.2812 32.7023 37.8415 32.7023 41.4729 31.7467C42.4596 31.4862 43.3592 30.9757 44.0816 30.2664C44.8041 29.5571 45.324 28.6739 45.5893 27.7053C46.5624 24.1402 46.5624 16.702 46.5624 16.702C46.5624 16.702 46.5624 9.26432 45.5893 5.69901Z",
                        fill: "#FF0000"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M18.625 23.5595L30.7218 16.7023L18.625 9.84521V23.5595ZM72.7464 26.6752C73.0013 26.0222 73.1293 24.9542 73.1293 23.472V17.2281C73.1293 15.7896 73.0013 14.7384 72.7464 14.0735C72.4911 13.4088 72.0415 13.0764 71.3982 13.0764C70.7764 13.0764 70.3375 13.4088 70.0825 14.0735C69.8272 14.7384 69.6996 15.7896 69.6996 17.2281V23.472C69.6996 24.9537 69.8215 26.0219 70.0661 26.6752C70.3099 27.3294 70.7537 27.6559 71.3979 27.6559C72.0415 27.6559 72.4911 27.3294 72.7464 26.6752ZM67.5856 29.8141C66.6638 29.2045 66.0086 28.2562 65.6209 26.9696C65.2322 25.6843 65.0382 23.9732 65.0382 21.8374V18.9277C65.0382 16.7704 65.2598 15.0375 65.7039 13.73C66.1478 12.4225 66.8411 11.4691 67.7851 10.8697C68.7286 10.2705 69.9661 9.97051 71.4979 9.97051C73.0074 9.97051 74.217 10.2759 75.1274 10.8858C76.0372 11.4959 76.7032 12.4498 77.1252 13.7464C77.5466 15.0432 77.7576 16.7704 77.7576 18.9279V21.8377C77.7576 23.9732 77.5524 25.69 77.1419 26.9862C76.7308 28.283 76.0648 29.2313 75.1438 29.8302C74.2225 30.4296 72.974 30.7293 71.3982 30.7293C69.7769 30.7293 68.5064 30.424 67.5856 29.8141ZM138.89 13.4506C138.658 13.7342 138.502 14.1973 138.424 14.84C138.346 15.4829 138.308 16.4582 138.308 17.7658V19.2042H141.671V17.7655C141.671 16.48 141.626 15.5046 141.538 14.8397C141.449 14.1751 141.288 13.7068 141.055 13.4342C140.822 13.1616 140.461 13.0253 139.973 13.0253C139.484 13.0253 139.123 13.1672 138.89 13.4503V13.4506ZM138.308 21.8851V22.8985C138.308 24.1846 138.346 25.149 138.424 25.7916C138.502 26.4348 138.662 26.9035 138.907 27.1976C139.151 27.4914 139.528 27.639 140.039 27.639C140.727 27.639 141.199 27.3774 141.454 26.8541C141.709 26.3312 141.848 25.4594 141.87 24.2385L145.833 24.4677C145.855 24.6427 145.866 24.8823 145.866 25.1868C145.866 27.0396 145.35 28.4239 144.318 29.3388C143.286 30.2538 141.826 30.7118 139.939 30.7118C137.675 30.7118 136.088 30.0147 135.178 28.6194C134.267 27.2253 133.812 25.0674 133.812 22.1467V18.6485C133.812 15.6409 134.284 13.4455 135.228 12.0609C136.171 10.6772 137.786 9.98519 140.073 9.98519C141.649 9.98519 142.858 10.2685 143.702 10.8352C144.545 11.4025 145.139 12.285 145.483 13.4833C145.828 14.6819 146 16.3386 146 18.4524V21.8851H138.308ZM56.3964 21.5097L51.1684 2.97339H55.73L57.5611 11.3751C58.0277 13.4464 58.3718 15.2117 58.5934 16.6713H58.7268C58.882 15.6254 59.2264 13.8711 59.759 11.4079L61.6571 2.97339H66.2188L60.9247 21.5097V30.4025H56.3961V21.5097M92.5944 10.3628V30.4025H88.9981L88.5985 27.9506H88.4988C87.5217 29.8031 86.0565 30.7291 84.1032 30.7291C82.7493 30.7291 81.7504 30.2936 81.1065 29.4215C80.4626 28.5503 80.1409 27.1877 80.1409 25.3349V10.3628H84.7359V25.0739C84.7359 25.968 84.836 26.6052 85.0358 26.9862C85.2355 27.3681 85.5684 27.5583 86.0347 27.5583C86.4342 27.5583 86.8171 27.4389 87.1833 27.1985C87.5496 26.9589 87.8215 26.6543 87.9992 26.2838V10.3625L92.5944 10.3628ZM116.165 10.3628V30.4025H112.568L112.168 27.9506H112.069C111.091 29.8031 109.626 30.7291 107.673 30.7291C106.319 30.7291 105.32 30.2936 104.676 29.4215C104.032 28.5503 103.711 27.1877 103.711 25.3349V10.3628H108.306V25.0739C108.306 25.968 108.406 26.6052 108.605 26.9862C108.805 27.3681 109.138 27.5583 109.604 27.5583C110.004 27.5583 110.387 27.4389 110.753 27.1985C111.12 26.9589 111.391 26.6543 111.569 26.2838V10.3625H116.164",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M105.081 6.603H100.519V30.4025H96.0236V6.60272H91.4619V2.97419H105.081V6.603ZM127.16 21.7402C127.16 23.2005 127.099 24.3449 126.977 25.1726C126.855 26.0015 126.649 26.5897 126.361 26.9379C126.072 27.2868 125.683 27.4612 125.196 27.4612C124.829 27.4642 124.467 27.3741 124.146 27.1995C123.824 27.0251 123.564 26.7638 123.364 26.415V15.038C123.519 14.4934 123.786 14.0466 124.163 13.6978C124.541 13.3495 124.951 13.1748 125.395 13.1748C125.861 13.1748 126.222 13.3546 126.477 13.7139C126.732 14.0737 126.91 14.6785 127.01 15.5285C127.11 16.3783 127.16 17.5879 127.16 19.1571V21.7402ZM131.372 13.566C131.094 12.3022 130.645 11.3869 130.023 10.82C129.402 10.2535 128.547 9.97019 127.46 9.97019C126.616 9.97019 125.828 10.2044 125.096 10.6729C124.373 11.1305 123.787 11.7679 123.397 12.5201H123.364L123.364 1.96045H118.936V30.4019H122.731L123.198 28.5062H123.297C123.652 29.1816 124.185 29.7156 124.896 30.1078C125.606 30.5001 126.394 30.6963 127.26 30.6963C128.813 30.6963 129.957 29.9933 130.69 28.5878C131.422 27.1818 131.788 24.9866 131.788 22.0005V18.8294C131.788 16.5849 131.649 14.8303 131.372 13.566Z",
                        fill: "white"
                    })
                ]
            });
        case "italic":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 12 12",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4 0V2H6.58L2.92 10H0V12H8V10H5.42L9.08 2H12V0H4Z",
                    fill: color
                })
            });
        case "italic-not":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 8 12",
                fill: color,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M0 0H8V2H5V10H8V12H0V10H3V2H0V0Z",
                    fill: color
                })
            });
        case "properties-linked":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 11 19",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M1.48492 1.42016C0.565686 2.33939 -1.2666e-07 3.61219 0.0707106 4.95569L0 6.58204C0 7.14772 0.424264 7.57198 0.98995 7.57198C1.55563 7.57198 1.9799 7.14772 1.9799 6.58204L1.9799 4.88498C1.9799 3.32934 3.39411 1.91513 4.94975 1.91513C5.79828 1.91513 6.57609 2.26868 7.14178 2.83437C7.70746 3.40005 8.06102 4.17787 7.99031 4.95569L8.06102 6.58204C8.06102 7.14772 8.48528 7.57198 9.05097 7.57198C9.33381 7.57198 9.61665 7.43056 9.75807 7.28914C9.8995 7.14772 10.0409 6.86488 10.0409 6.58204L10.0409 4.88498C10.0409 3.61219 9.47523 2.33939 8.55599 1.42016C7.63675 0.500917 6.36396 -0.0647687 5.02046 0.00594198C3.67696 -0.0647687 2.40416 0.500917 1.48492 1.42016Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8.06102 11.8147V13.5118C8.06102 15.0674 6.6468 16.4816 5.09117 16.4816C4.24264 16.4816 3.46482 16.128 2.89914 15.5624C2.33345 14.9967 1.9799 14.2189 2.05061 13.441L1.9799 11.8147C1.9799 11.249 1.55563 10.8247 0.98995 10.8247C0.424264 10.8247 0 11.249 0 11.8147L0.0707106 13.441C-1.2666e-07 14.7845 0.565686 16.0573 1.48492 16.9766C2.40416 17.8958 3.67696 18.4615 5.02046 18.3908C6.36396 18.4615 7.63675 17.8958 8.55599 16.9766C9.47523 16.0573 10.0409 14.7845 9.97021 13.441V11.744C9.97021 11.1783 9.54594 10.754 8.98026 10.754C8.41457 10.754 8.06102 11.249 8.06102 11.8147Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M4.03064 6.22815L4.03064 12.1678C4.03064 12.7335 4.4549 13.1578 5.02059 13.1578C5.30343 13.1578 5.58627 13.0164 5.72769 12.875C5.86911 12.7335 6.01054 12.4507 6.01054 12.1678L6.01054 6.22815C6.01054 5.66246 5.58627 5.2382 5.02059 5.2382C4.4549 5.2382 4.03064 5.66247 4.03064 6.22815Z",
                        fill: color
                    })
                ]
            });
        case "properties-unlinked":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 11 19",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M1.48492 1.42016C0.565686 2.33939 -1.2666e-07 3.61219 0.0707106 4.95569L0 6.58204C0 7.14772 0.424264 7.57198 0.98995 7.57198C1.55563 7.57198 1.9799 7.14772 1.9799 6.58204L1.9799 4.88498C1.9799 3.32934 3.39411 1.91513 4.94975 1.91513C5.79828 1.91513 6.57609 2.26868 7.14178 2.83437C7.70746 3.40005 8.06102 4.17787 7.99031 4.95569L8.06102 6.58204C8.06102 7.14772 8.48528 7.57198 9.05097 7.57198C9.33381 7.57198 9.61665 7.43056 9.75807 7.28914C9.8995 7.14772 10.0409 6.86488 10.0409 6.58204L10.0409 4.88498C10.0409 3.61219 9.47523 2.33939 8.55599 1.42016C7.63675 0.500917 6.36396 -0.0647687 5.02046 0.00594198C3.67696 -0.0647687 2.40416 0.500917 1.48492 1.42016Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8.06102 11.8147V13.5118C8.06102 15.0674 6.6468 16.4816 5.09117 16.4816C4.24264 16.4816 3.46482 16.128 2.89914 15.5624C2.33345 14.9967 1.9799 14.2189 2.05061 13.441L1.9799 11.8147C1.9799 11.249 1.55563 10.8247 0.98995 10.8247C0.424264 10.8247 0 11.249 0 11.8147L0.0707106 13.441C-1.2666e-07 14.7845 0.565686 16.0573 1.48492 16.9766C2.40416 17.8958 3.67696 18.4615 5.02046 18.3908C6.36396 18.4615 7.63675 17.8958 8.55599 16.9766C9.47523 16.0573 10.0409 14.7845 9.97021 13.441V11.744C9.97021 11.1783 9.54594 10.754 8.98026 10.754C8.41457 10.754 8.06102 11.249 8.06102 11.8147Z",
                        fill: color
                    })
                ]
            });
        case "corners-all":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2ZM3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H13C14.6569 16 16 14.6569 16 13V3C16 1.34315 14.6569 0 13 0H3Z",
                    fill: color
                })
            });
        case "corners-individual":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M3 0H5C5.55228 0 6 0.447715 6 1C6 1.55228 5.55228 2 5 2H3C2.44772 2 2 2.44772 2 3V5C2 5.55228 1.55228 6 1 6C0.447715 6 0 5.55228 0 5V3C0 1.34315 1.34315 0 3 0Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M1 10C0.447715 10 0 10.4477 0 11V13C0 14.6569 1.34315 16 3 16H5C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14H3C2.44772 14 2 13.5523 2 13V11C2 10.4477 1.55228 10 1 10Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M15 10C14.4477 10 14 10.4477 14 11V13C14 13.5523 13.5523 14 13 14H11C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H13C14.6569 16 16 14.6569 16 13V11C16 10.4477 15.5523 10 15 10Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M15 6C15.5523 6 16 5.55228 16 5V3C16 1.34315 14.6569 0 13 0H11C10.4477 0 10 0.447715 10 1C10 1.55228 10.4477 2 11 2H13C13.5523 2 14 2.44772 14 3V5C14 5.55228 14.4477 6 15 6Z",
                        fill: color
                    })
                ]
            });
        case "node-number":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 12 12",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeWidth: "1",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "3",
                            y1: "11.5",
                            x2: "5",
                            y2: "0.5",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "7",
                            y1: "11.5",
                            x2: "9",
                            y2: "0.5",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "2",
                            y1: "3.5",
                            x2: "11",
                            y2: "3.5",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "1",
                            y1: "7.5",
                            x2: "10",
                            y2: "7.5",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            });
        case "bookmark":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                height: height,
                width: width,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M19,0H5A3,3,0,0,0,2,3V23.5a.5.5,0,0,0,.767.423L12,18.092l9.233,5.831A.493.493,0,0,0,21.5,24a.5.5,0,0,0,.5-.5V3A3,3,0,0,0,19,0Z"
                    })
                })
            });
        case "kebab":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            fill: color,
                            cx: "12",
                            cy: "12",
                            r: "2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            fill: color,
                            cx: "3",
                            cy: "12",
                            r: "2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            fill: color,
                            cx: "21",
                            cy: "12",
                            r: "2"
                        })
                    ]
                })
            });
        case "check-thick":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M15.854,3.146l-1.5-1.5c-.195-.195-.512-.195-.707,0L5.5,9.793l-3.146-3.146c-.195-.195-.512-.195-.707,0L.146,8.146c-.195,.195-.195,.512,0,.707l5,5c.098,.098,.226,.146,.354,.146s.256-.049,.354-.146L15.854,3.854c.195-.195,.195-.512,0-.707Z",
                        fill: color
                    })
                })
            });
        case "node-navigation":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                fill: "none",
                viewBox: "0 0 16 16",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M2.5 3.20001V15.3H11.3",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeOpacity: "0.87",
                        strokeWidth: "1.16667"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M13.5 1H4.70001V13.1H13.5V1Z",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeOpacity: "0.87",
                        strokeWidth: "1.16667"
                    })
                ]
            });
        case "node-stack":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "4",
                            y: "1",
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            width: "16",
                            height: "7"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "4",
                            y: "16",
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            width: "16",
                            height: "7"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            x1: "1",
                            y1: "12",
                            x2: "23",
                            y2: "12"
                        })
                    ]
                })
            });
        case "node-z-stack":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polygon", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            points: "2,7 12,1 22,7 12,13 "
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            points: " 22,12 12,18 2,12 "
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            points: " 22,17 12,23 2,17 "
                        })
                    ]
                })
            });
        case "node-animation":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            cx: "19",
                            cy: "9",
                            r: "4"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            d: "M7,20c0-4.708,2.625-8,5.514-9",
                            strokeLinecap: "butt"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            d: "M1,5c5,2.917,6,9.583,6,15",
                            strokeLinecap: "butt"
                        })
                    ]
                })
            });
        case "node-video":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeWidth: "1",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "0.5",
                            y: "2.5",
                            width: "15",
                            height: "12",
                            rx: "1",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polygon", {
                            points: "6.5 5.5 11.5 8.5 6.5 11.5 6.5 5.5",
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            "data-color": "color-2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "3.5",
                            y1: "0.5",
                            x2: "12.5",
                            y2: "0.5",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            });
        case "node-expand-all":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12.769,2.359a1.037,1.037,0,0,0-1.538,0l-5,6A1,1,0,0,0,7,10H17a1,1,0,0,0,.769-1.641Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M17,14H7a1,1,0,0,0-.769,1.641l5,6a1,1,0,0,0,1.538,0l5-6A1,1,0,0,0,17,14Z"
                        })
                    ]
                })
            });
        case "node-collapse-all":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12.769 14.3607C12.6718 14.2533 12.5531 14.1674 12.4207 14.1086C12.2882 14.0498 12.1449 14.0194 12 14.0194C11.8551 14.0194 11.7118 14.0498 11.5793 14.1086C11.4469 14.1674 11.3282 14.2533 11.231 14.3607L6.231 20.3607C6.10903 20.5068 6.03126 20.6846 6.00682 20.8733C5.98238 21.062 6.01229 21.2538 6.09303 21.4261C6.17377 21.5984 6.302 21.7441 6.46265 21.846C6.6233 21.948 6.80971 22.002 7 22.0017H17C17.1903 22.002 17.3767 21.948 17.5373 21.846C17.698 21.7441 17.8262 21.5984 17.907 21.4261C17.9877 21.2538 18.0176 21.062 17.9932 20.8733C17.9687 20.6846 17.891 20.5068 17.769 20.3607L12.769 14.3607Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M17 2.0177H7C6.80971 2.01742 6.6233 2.07144 6.46265 2.17341C6.302 2.27538 6.17377 2.42106 6.09303 2.59336C6.01229 2.76567 5.98238 2.95743 6.00682 3.14613C6.03126 3.33484 6.10903 3.51265 6.231 3.6587L11.231 9.6587C11.3248 9.77159 11.4424 9.86244 11.5753 9.92478C11.7082 9.98713 11.8532 10.0195 12 10.0195C12.1468 10.0195 12.2918 9.98713 12.4247 9.92478C12.5576 9.86244 12.6752 9.77159 12.769 9.6587L17.769 3.6587C17.891 3.51265 17.9687 3.33484 17.9932 3.14613C18.0176 2.95743 17.9877 2.76567 17.907 2.59336C17.8262 2.42106 17.698 2.27538 17.5373 2.17341C17.3767 2.07144 17.1903 2.01742 17 2.0177Z",
                        fill: color
                    })
                ]
            });
        case "plus":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "12",
                            y1: "2",
                            x2: "12",
                            y2: "22"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "22",
                            y1: "12",
                            x2: "2",
                            y2: "12"
                        })
                    ]
                })
            });
        case "plus-thick":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "3",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "12",
                            y1: "2",
                            x2: "12",
                            y2: "22"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "22",
                            y1: "12",
                            x2: "2",
                            y2: "12"
                        })
                    ]
                })
            });
        case "node-text":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "12",
                            y1: "2",
                            x2: "12",
                            y2: "22",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "butt"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "8",
                            y1: "22",
                            x2: "16",
                            y2: "22",
                            fill: "none",
                            stroke: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            points: "21 5 19 2 5 2 3 5",
                            fill: "none",
                            stroke: color
                        })
                    ]
                })
            });
        case "node-div":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                        x: "2",
                        y: "2",
                        width: "20",
                        height: "20",
                        fill: "none",
                        stroke: color,
                        strokeMiterlimit: "10"
                    })
                })
            });
        case "node-image":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeWidth: "1",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            d: "M14.5,15.5h-13 c-0.552,0-1-0.448-1-1v-13c0-0.552,0.448-1,1-1h13c0.552,0,1,0.448,1,1v13C15.5,15.052,15.052,15.5,14.5,15.5z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            points: "2.5,12.5 9.5,7.5 13.5,11.5 ",
                            "data-color": "color-2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            cx: "4.5",
                            cy: "5.5",
                            r: "1.5",
                            "data-color": "color-2",
                            "data-stroke": "none",
                            stroke: "none"
                        })
                    ]
                })
            });
        case "triangle-right":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M16.53,11.152l-8-5C8.221,5.958,7.833,5.949,7.515,6.125C7.197,6.302,7,6.636,7,7v10 c0,0.364,0.197,0.698,0.515,0.875C7.667,17.958,7.833,18,8,18c0.184,0,0.368-0.051,0.53-0.152l8-5C16.822,12.665,17,12.345,17,12 S16.822,11.335,16.53,11.152z"
                    })
                })
            });
        case "undo":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M11,7.008V1.5a.5.5,0,0,0-.845-.362l-10,9.5a.5.5,0,0,0,0,.724l10,9.5a.5.5,0,0,0,.542.1A.5.5,0,0,0,11,20.5V15.007c9.12.252,11.916,7.361,12.032,7.669A.5.5,0,0,0,23.5,23a.466.466,0,0,0,.09-.009A.5.5,0,0,0,24,22.5C24,9.058,15.283,7.138,11,7.008Z",
                        fill: color
                    })
                })
            });
        case "redo":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M23.86,10.638l-10-9.5a.5.5,0,0,0-.844.362V6.007A12.187,12.187,0,0,0,4.094,9.693C-.43,14.508,0,22.206.017,22.531a.5.5,0,0,0,.424.463A.474.474,0,0,0,.516,23a.5.5,0,0,0,.467-.324c.117-.308,2.913-7.418,12.033-7.669V20.5a.5.5,0,0,0,.844.362l10-9.5a.5.5,0,0,0,0-.724Z",
                        fill: color
                    })
                })
            });
        case "confused":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 48 48",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M24,2A22,22,0,1,0,46,24,22.025,22.025,0,0,0,24,2ZM11,22a3,3,0,1,1,3,3A3,3,0,0,1,11,22ZM32,35H16a1,1,0,0,1,0-2H32a1,1,0,0,1,0,2Zm2-10a3,3,0,1,1,3-3A3,3,0,0,1,34,25Z",
                        fill: color
                    })
                })
            });
        case "notification":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M21.855,18.482A12.85,12.85,0,0,1,20,11.994V8.006a8,8,0,0,0-16,0v3.982a12.851,12.851,0,0,1-1.855,6.494A1,1,0,0,0,3,20H21a1,1,0,0,0,.855-1.518Z",
                            fill: color
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M13.007,23.825a3,3,0,0,0,1.819-1.819H9.174A3,3,0,0,0,13.007,23.825Z"
                        })
                    ]
                })
            });
        case "code":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M5,13c-.256,0-.512-.098-.707-.293L.293,8.707c-.391-.391-.391-1.023,0-1.414L4.293,3.293c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414l-3.293,3.293,3.293,3.293c.391,.391,.391,1.023,0,1.414-.195,.195-.451,.293-.707,.293Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M11,13c-.256,0-.512-.098-.707-.293-.391-.391-.391-1.023,0-1.414l3.293-3.293-3.293-3.293c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l4,4c.391,.391,.391,1.023,0,1.414l-4,4c-.195,.195-.451,.293-.707,.293Z"
                        })
                    ]
                })
            });
        case "settings":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M20.872,13.453A9.033,9.033,0,0,0,21,12a9.033,9.033,0,0,0-.128-1.453l2.1-2.029A1,1,0,0,0,23.143,7.3l-1.5-2.6A1.009,1.009,0,0,0,20.5,4.239l-2.8.8a9.017,9.017,0,0,0-2.527-1.451L14.47.758A1,1,0,0,0,13.5,0h-3a1,1,0,0,0-.97.758l-.707,2.83A9.017,9.017,0,0,0,6.3,5.039l-2.8-.8A1.01,1.01,0,0,0,2.357,4.7L.857,7.3a1,1,0,0,0,.171,1.219l2.1,2.029A9.033,9.033,0,0,0,3,12a9.033,9.033,0,0,0,.128,1.453l-2.1,2.029A1,1,0,0,0,.857,16.7l1.5,2.6a1,1,0,0,0,.867.5,1.048,1.048,0,0,0,.275-.038l2.8-.8a9.017,9.017,0,0,0,2.527,1.451l.707,2.83A1,1,0,0,0,10.5,24h3a1,1,0,0,0,.97-.758l.707-2.83A9.017,9.017,0,0,0,17.7,18.961l2.8.8a1.048,1.048,0,0,0,.275.038,1,1,0,0,0,.867-.5l1.5-2.6a1,1,0,0,0-.171-1.219ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"
                    })
                })
            });
        case "pain-brush":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M3,8.272L1.586,9.686c-0.781,0.781-0.781,2.047,0,2.828l2.828,2.828L0.957,18.8 c-1.025,1.025-1.273,2.659-0.46,3.859c1.096,1.616,3.314,1.771,4.624,0.462l3.536-3.536l2.828,2.828 c0.781,0.781,2.047,0.781,2.828,0L15.728,21L3,8.272z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M22.799,13.929c0.39-0.39,0.39-1.024,0-1.414l-2.121-2.121l-4.243,1.414l1.414-4.243 l-6.364-6.364c-0.39-0.39-1.024-0.39-1.414,0L4.414,6.858l12.728,12.728L22.799,13.929z"
                        })
                    ]
                })
            });
        case "survey":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    className: className,
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M23,5H12c-.552,0-1,.448-1,1s.448,1,1,1h11c.552,0,1-.448,1-1s-.448-1-1-1Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "1",
                            y: "2",
                            width: "8",
                            height: "8",
                            rx: "1",
                            ry: "1",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M23,17H12c-.552,0-1,.448-1,1s.448,1,1,1h11c.552,0,1-.448,1-1s-.448-1-1-1Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M4,21c-.256,0-.512-.098-.707-.293l-2-2c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l1.293,1.293,5.293-5.293c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414l-6,6c-.195,.195-.451,.293-.707,.293Z"
                        })
                    ]
                })
            });
        case "back":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8.293,4.293l-7,7a1,1,0,0,0,0,1.414l7,7a1,1,0,0,0,1.414-1.414L4.414,13H22a1,1,0,0,0,0-2H4.414L9.707,5.707A1,1,0,1,0,8.293,4.293Z",
                        fill: color
                    })
                })
            });
        case "layout":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M24,8H0V2c0-0.552,0.448-1,1-1h22c0.552,0,1,0.448,1,1V8z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M7,23H1c-0.552,0-1-0.448-1-1V10h7V23z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M23,23H9V10h15v12C24,22.552,23.552,23,23,23z"
                        })
                    ]
                })
            });
        case "language":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                stroke: "currentColor",
                fill: "currentColor",
                strokeWidth: "0",
                viewBox: "0 0 512 512",
                width: width,
                height: height,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M478.33 433.6l-90-218a22 22 0 00-40.67 0l-90 218a22 22 0 1040.67 16.79L316.66 406h102.67l18.33 44.39A22 22 0 00458 464a22 22 0 0020.32-30.4zM334.83 362L368 281.65 401.17 362zm-66.99-19.08a22 22 0 00-4.89-30.7c-.2-.15-15-11.13-36.49-34.73 39.65-53.68 62.11-114.75 71.27-143.49H330a22 22 0 000-44H214V70a22 22 0 00-44 0v20H54a22 22 0 000 44h197.25c-9.52 26.95-27.05 69.5-53.79 108.36-31.41-41.68-43.08-68.65-43.17-68.87a22 22 0 00-40.58 17c.58 1.38 14.55 34.23 52.86 83.93.92 1.19 1.83 2.35 2.74 3.51-39.24 44.35-77.74 71.86-93.85 80.74a22 22 0 1021.07 38.63c2.16-1.18 48.6-26.89 101.63-85.59 22.52 24.08 38 35.44 38.93 36.1a22 22 0 0030.75-4.9z"
                })
            });
        case "chevron-right-light":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                        fill: "none",
                        stroke: color,
                        strokeMiterlimit: "10",
                        points: "7,2 17,12 7,22 ",
                        transform: "translate(0, 0)"
                    })
                })
            });
        case "info-filled":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8,0a8,8,0,1,0,8,8A8.024,8.024,0,0,0,8,0Zm.5,13h-1a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,7.5,7h1a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,8.5,13ZM8,5A.945.945,0,0,1,7,4,.945.945,0,0,1,8,3,.945.945,0,0,1,9,4,.945.945,0,0,1,8,5Z",
                        fill: color
                    })
                })
            });
        case "forward":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M23.86,10.638l-10-9.5a.5.5,0,0,0-.844.362V6.007A12.187,12.187,0,0,0,4.094,9.693C-.43,14.508,0,22.206.017,22.531a.5.5,0,0,0,.424.463A.474.474,0,0,0,.516,23a.5.5,0,0,0,.467-.324c.117-.308,2.913-7.418,12.033-7.669V20.5a.5.5,0,0,0,.844.362l10-9.5a.5.5,0,0,0,0-.724Z",
                        fill: color
                    })
                })
            });
        case "google-play":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 137 154",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M2.62965 2.92578C0.851868 4.70356 0.259277 7.66652 0.259277 11.2221V142.185C0.259277 145.741 1.44446 148.704 3.22224 150.481L3.81484 151.074L77.2963 77.5924V76.4073L2.62965 2.92578Z",
                        fill: "url(#paint0_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M101 102.481L76.7037 78.1852V76.4074L101 52.1111L101.593 52.7037L130.63 69.2963C138.926 74.037 138.926 81.7407 130.63 86.4815L101 102.481Z",
                        fill: "url(#paint1_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M101.593 101.889L76.7037 77L2.62964 151.074C5.5926 154.037 9.74075 154.037 15.0741 151.667L101.593 101.889Z",
                        fill: "url(#paint2_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M101.593 52.1112L15.0741 2.92603C9.74075 -0.0369332 5.5926 0.555659 2.62964 3.51862L76.7037 77.0001L101.593 52.1112Z",
                        fill: "url(#paint3_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        opacity: "0.2",
                        d: "M101 101.296L15.0741 149.889C10.3333 152.852 6.1852 152.259 3.22223 149.889L2.62964 150.482L3.22223 151.074C6.1852 153.445 10.3333 154.037 15.0741 151.074L101 101.296Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        opacity: "0.12",
                        d: "M2.62965 149.889C0.851868 148.111 0.259277 145.148 0.259277 141.593V142.185C0.259277 145.741 1.44446 148.704 3.22224 150.481V149.889H2.62965ZM130.63 84.7037L101 101.296L101.593 101.889L130.63 85.2963C134.778 82.9259 136.556 79.963 136.556 77C136.556 79.963 134.185 82.3333 130.63 84.7037Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        opacity: "0.25",
                        d: "M15.0741 3.51852L130.63 69.2963C134.185 71.6667 136.556 74.037 136.556 77C136.556 74.037 134.778 71.0741 130.63 68.7037L15.0741 2.92593C6.7778 -1.81481 0.259277 1.74074 0.259277 11.2222V11.8148C0.259277 2.92593 6.7778 -1.22222 15.0741 3.51852Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint0_linear_795_114",
                                x1: "70.1852",
                                y1: "10.0962",
                                x2: "-29.2696",
                                y2: "109.545",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#00A0FF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.007",
                                        stopColor: "#00A1FF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.26",
                                        stopColor: "#00BEFF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.512",
                                        stopColor: "#00D2FF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.76",
                                        stopColor: "#00DFFF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#00E3FF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint1_linear_795_114",
                                x1: "141.498",
                                y1: "77.0059",
                                x2: "-1.89182",
                                y2: "77.0059",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#FFE000"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.409",
                                        stopColor: "#FFBD00"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.775",
                                        stopColor: "#FFA500"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#FF9C00"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint2_linear_795_114",
                                x1: "88.123",
                                y1: "90.6059",
                                x2: "-46.7392",
                                y2: "225.468",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#FF3A44"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#C31162"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint3_linear_795_114",
                                x1: "-15.7585",
                                y1: "-40.4755",
                                x2: "44.4667",
                                y2: "19.7497",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#32A071"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.069",
                                        stopColor: "#2DA771"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.476",
                                        stopColor: "#15CF74"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.801",
                                        stopColor: "#06E775"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#00F076"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        case "subscription-revenue":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M21.055,19.848A11.981,11.981,0,0,0,12,0a1,1,0,0,0,0,2,9.986,9.986,0,0,1,7.64,16.433l-1.786-1.787a.5.5,0,0,0-.847.272l-1,6a.5.5,0,0,0,.493.582.454.454,0,0,0,.082-.007l6-1a.5.5,0,0,0,.272-.847Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12,22A9.988,9.988,0,0,1,4.359,5.566L6.146,7.354A.5.5,0,0,0,6.5,7.5a.5.5,0,0,0,.493-.418l1-6A.5.5,0,0,0,7.418.507l-6,1a.5.5,0,0,0-.272.847L2.935,4.142A12,12,0,0,0,12,24a1,1,0,0,0,0-2Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M15.983,14.214a2.554,2.554,0,0,1-.887,2,4.508,4.508,0,0,1-2.561.971V19H11.423V17.234A8.637,8.637,0,0,1,8.017,16.6V14.833a8.566,8.566,0,0,0,1.682.59,7.606,7.606,0,0,0,1.724.247V12.54l-.7-.26a4.948,4.948,0,0,1-2.005-1.259A2.674,2.674,0,0,1,8.084,9.21a2.358,2.358,0,0,1,.9-1.9,4.458,4.458,0,0,1,2.44-.9V5h1.112V6.381a9.241,9.241,0,0,1,3.222.686L15.146,8.6a9.005,9.005,0,0,0-2.611-.619v3.046l.636.243a5.794,5.794,0,0,1,2.2,1.289A2.385,2.385,0,0,1,15.983,14.214ZM10.05,9.193a1.121,1.121,0,0,0,.3.794,3.016,3.016,0,0,0,1.076.628v-2.6a1.952,1.952,0,0,0-1.022.41A.989.989,0,0,0,10.05,9.193Zm3.958,5.146a1.043,1.043,0,0,0-.339-.8,3.473,3.473,0,0,0-1.134-.607V15.6Q14.008,15.377,14.008,14.339Z"
                        })
                    ]
                })
            });
        case "more-info":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "8",
                            cy: "8",
                            r: "3"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M3.7,2.387A1,1,0,0,0,2.286,2.4a8,8,0,0,0,0,11.2,1,1,0,1,0,1.428-1.4,6,6,0,0,1,0-8.4A1,1,0,0,0,3.7,2.387Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M13.714,2.4a1,1,0,1,0-1.428,1.4,6,6,0,0,1,0,8.4,1,1,0,0,0,1.428,1.4,8,8,0,0,0,0-11.2Z",
                            fill: color
                        })
                    ]
                })
            });
        case "apple":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: color,
                height: height,
                width: width,
                className: className,
                version: "1.1",
                id: "Capa_1",
                viewBox: "0 0 22.773 22.773",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573    c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334    c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0    c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019    c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464    c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648    c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {})
                    ]
                })
            });
        case "product":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                height: height,
                width: width,
                className: className,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M15.414,8,7.707.293A1,1,0,0,0,7,0H1A1,1,0,0,0,0,1V7a1,1,0,0,0,.293.707L8,15.414a2,2,0,0,0,2.828,0l4.586-4.586A2,2,0,0,0,15.414,8ZM5,6.5A1.5,1.5,0,1,1,6.5,5,1.5,1.5,0,0,1,5,6.5Z",
                        fill: color
                    })
                })
            });
        case "pencil":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                stroke: color,
                fill: color,
                strokeWidth: 0,
                viewBox: "0 0 24 24",
                height: height,
                width: width,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: "none",
                        d: "M0 0h24v24H0z"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"
                    })
                ]
            });
        case "archive":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M3,2H13c.6,0,1-.4,1-1s-.4-1-1-1H3c-.6,0-1,.4-1,1s.4,1,1,1Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M15,4H1c-.6,0-1,.4-1,1V15c0,.6,.4,1,1,1H15c.6,0,1-.4,1-1V5c0-.6-.4-1-1-1Zm-4,6H5c-.552,0-1-.447-1-1s.448-1,1-1h6c.552,0,1,.447,1,1s-.448,1-1,1Z",
                            fill: color
                        })
                    ]
                })
            });
        case "crown":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polygon", {
                            points: "24 15 24 1.586 17.938 7.647 12 2.698 6.062 7.647 0 1.586 0 15 24 15",
                            fill: color
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M0,17v2a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V17Z"
                        })
                    ]
                })
            });
        case "megaphone":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M8.438,11.5H3.969l1.76,3.412a2,2,0,1,0,3.555-1.831Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M14.691.038a.5.5,0,0,0-.545.108C14.118.175,11.254,3,8.5,3h-5a3.5,3.5,0,0,0,0,7h5c2.754,0,5.618,2.825,5.646,2.854A.5.5,0,0,0,15,12.5V.5A.5.5,0,0,0,14.691.038Z",
                            fill: color
                        })
                    ]
                })
            });
        case "node-drawer":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M13 1H3V14.9335H13V1Z",
                        stroke: color,
                        "stroke-opacity": "0.87",
                        "stroke-width": "1.16667",
                        "stroke-miterlimit": "10",
                        "stroke-linecap": "square"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M6.21545 4.21542L9.78459 4.21542",
                        stroke: color,
                        "stroke-opacity": "0.87",
                        "stroke-miterlimit": "10",
                        "stroke-linecap": "square"
                    })
                ]
            });
        case "open":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M22,1H14a1,1,0,0,0-.707,1.707L16.586,6l-6.293,6.293a1,1,0,1,0,1.414,1.414L18,7.414l3.293,3.293A1,1,0,0,0,22,11a.987.987,0,0,0,.383-.076A1,1,0,0,0,23,10V2A1,1,0,0,0,22,1Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M4,23H18a3,3,0,0,0,3-3V15a1,1,0,0,0-2,0v5a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V6A1,1,0,0,1,4,5H9A1,1,0,0,0,9,3H4A3,3,0,0,0,1,6V20A3,3,0,0,0,4,23Z",
                            fill: color
                        })
                    ]
                })
            });
        case "download":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12,1a1,1,0,0,0-1,1v8H7a1,1,0,0,0-.768,1.641l5,6a1,1,0,0,0,1.536,0l5-6A1,1,0,0,0,17,10H13V2A1,1,0,0,0,12,1Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M22,21H2a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"
                        })
                    ]
                })
            });
        case "download-alt":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M11.2,16.6c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047 C21.725,3.214,21.379,3,21,3H3C2.621,3,2.275,3.214,2.105,3.553C1.937,3.892,1.973,4.297,2.2,4.6L11.2,16.6z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M21,19H3c-0.553,0-1,0.447-1,1s0.447,1,1,1h18c0.553,0,1-0.447,1-1S21.553,19,21,19z"
                        })
                    ]
                })
            });
        case "file":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 48 48",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#E6E6E6",
                            d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l34,0c1.105,0,2,0.895,2,2v42 C43,46.105,42.105,47,41,47z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "19",
                            y: "1",
                            fill: "#444444",
                            width: "10",
                            height: "22"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "24",
                            y: "1",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "21",
                            y: "3",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "24",
                            y: "5",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "21",
                            y: "7",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "24",
                            y: "9",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "21",
                            y: "11",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "24",
                            y: "13",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "21",
                            y: "15",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "24",
                            y: "17",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "21",
                            y: "19",
                            fill: "#E6E6E6",
                            width: "3",
                            height: "2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#B3B3B3",
                            d: "M21,23v5c0,1.657,1.343,3,3,3s3-1.343,3-3v-5H21z M25,28h-2v-2h2V28z"
                        })
                    ]
                })
            });
        case "csv":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 48 48",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polygon", {
                            fill: "#0E512B",
                            points: "44,27 4,27 1,23 5,19 43,19 47,23 "
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#E6E6E6",
                            d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#B3B3B3",
                            d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#1B7343",
                            d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M17.786,29.775c-0.505,0-0.899,0.206-1.182,0.62c-0.283,0.413-0.424,0.983-0.424,1.71 c0,1.512,0.575,2.268,1.724,2.268c0.347,0,0.684-0.049,1.01-0.146s0.653-0.213,0.983-0.349v1.793 c-0.655,0.291-1.396,0.436-2.224,0.436c-1.185,0-2.094-0.344-2.726-1.031c-0.632-0.688-0.948-1.682-0.948-2.98 c0-0.813,0.153-1.527,0.459-2.144c0.307-0.616,0.747-1.09,1.321-1.421c0.575-0.331,1.251-0.496,2.028-0.496 c0.849,0,1.66,0.184,2.433,0.553l-0.65,1.67c-0.29-0.136-0.58-0.25-0.87-0.344C18.43,29.821,18.119,29.775,17.786,29.775z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M26.562,33.615c0,0.487-0.124,0.919-0.371,1.297s-0.604,0.672-1.069,0.881 c-0.465,0.21-1.012,0.314-1.638,0.314c-0.523,0-0.961-0.037-1.316-0.11s-0.723-0.201-1.106-0.384v-1.891 c0.405,0.208,0.825,0.37,1.262,0.486s0.838,0.174,1.203,0.174c0.315,0,0.546-0.054,0.693-0.163s0.22-0.25,0.22-0.422 c0-0.107-0.03-0.201-0.088-0.282c-0.06-0.08-0.154-0.162-0.285-0.244c-0.13-0.082-0.479-0.251-1.044-0.505 c-0.512-0.232-0.896-0.458-1.152-0.677c-0.256-0.219-0.446-0.469-0.569-0.752c-0.124-0.283-0.186-0.617-0.186-1.004 c0-0.724,0.263-1.288,0.79-1.692s1.25-0.606,2.17-0.606c0.813,0,1.642,0.188,2.487,0.563l-0.65,1.638 c-0.734-0.336-1.368-0.504-1.901-0.504c-0.276,0-0.476,0.048-0.602,0.145s-0.188,0.217-0.188,0.359c0,0.154,0.08,0.292,0.239,0.414 c0.159,0.122,0.591,0.344,1.297,0.666c0.677,0.305,1.146,0.631,1.41,0.98C26.43,32.646,26.562,33.085,26.562,33.615z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M32.186,28.147h2.374L31.987,36h-2.498l-2.562-7.853h2.385l1.069,3.979c0.222,0.885,0.344,1.501,0.365,1.848 c0.025-0.25,0.075-0.563,0.15-0.939s0.142-0.672,0.199-0.887L32.186,28.147z"
                        })
                    ]
                })
            });
        case "pdf":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 48 48",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polygon", {
                            fill: "#870000",
                            points: "44,27 4,27 1,23 5,19 43,19 47,23 "
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#E6E6E6",
                            d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#B3B3B3",
                            d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#BD0100",
                            d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M20.071,30.645c0,0.878-0.259,1.556-0.776,2.033c-0.518,0.479-1.252,0.717-2.205,0.717h-0.596V36h-2.122 v-7.853h2.718c0.992,0,1.737,0.217,2.234,0.649C19.822,29.23,20.071,29.847,20.071,30.645z M16.494,31.666h0.387 c0.319,0,0.572-0.09,0.76-0.27c0.188-0.179,0.282-0.426,0.282-0.74c0-0.53-0.293-0.795-0.881-0.795h-0.548V31.666z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M27.988,31.907c0,1.311-0.361,2.32-1.083,3.029C26.184,35.646,25.17,36,23.863,36h-2.541v-7.853h2.718 c1.26,0,2.233,0.322,2.919,0.967C27.645,29.759,27.988,30.689,27.988,31.907z M25.786,31.982c0-0.72-0.142-1.253-0.427-1.601 c-0.284-0.348-0.717-0.521-1.297-0.521h-0.618v4.398h0.473c0.645,0,1.117-0.188,1.418-0.562S25.786,32.752,25.786,31.982z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M31.484,36h-2.089v-7.853h4.641v1.702h-2.551v1.499h2.353v1.702h-2.353V36z"
                        })
                    ]
                })
            });
        case "menu":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M15,7H1C0.4,7,0,7.4,0,8s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,7,15,7z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M15,1H1C0.4,1,0,1.4,0,2s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,1,15,1z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M15,13H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,13,15,13z"
                        })
                    ]
                })
            }, "filter-icon-1");
        case "play":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M14,7.999c0-0.326-0.159-0.632-0.427-0.819l-10-7C3.269-0.034,2.869-0.058,2.538,0.112 C2.207,0.285,2,0.626,2,0.999v14.001c0,0.373,0.207,0.715,0.538,0.887c0.331,0.17,0.73,0.146,1.035-0.068l10-7 C13.841,8.633,14,8.327,14,8.001C14,8,14,8,14,7.999C14,8,14,8,14,7.999z"
                    })
                })
            }, "filter-icon-2");
        case "pause":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M5,1H2C1.4,1,1,1.4,1,2v12c0,0.6,0.4,1,1,1h3c0.6,0,1-0.4,1-1V2C6,1.4,5.6,1,5,1z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M14,1h-3c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1h3c0.6,0,1-0.4,1-1V2C15,1.4,14.6,1,14,1z"
                        })
                    ]
                })
            }, "filter-icon-3");
        case "trash-box":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M14,7H2v7c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V7z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            height: "4",
                            width: "16",
                            y: "1"
                        })
                    ]
                })
            }, "filter-icon-4");
        case "copy":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M22,7h-3v11c0,0.552-0.448,1-1,1H7v3c0,0.552,0.448,1,1,1h14c0.552,0,1-0.448,1-1V8 C23,7.448,22.552,7,22,7z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M16,17H2c-0.553,0-1-0.447-1-1V2c0-0.552,0.447-1,1-1h14c0.553,0,1,0.448,1,1v14C17,16.553,16.553,17,16,17z "
                        })
                    ]
                })
            });
        case "trash":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M3.87,21.214A3.01,3.01,0,0,0,6.862,24H17.138a3.01,3.01,0,0,0,2.992-2.786L21.074,8H2.926Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M23,4H17V1a1,1,0,0,0-1-1H8A1,1,0,0,0,7,1V4H1A1,1,0,0,0,1,6H23a1,1,0,0,0,0-2ZM9,2h6V4H9Z"
                        })
                    ]
                })
            });
        case "star":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12.746,1.464l3.11,6.3L22.81,8.776a.831.831,0,0,1,.461,1.418l-5.033,4.9,1.188,6.926a.832.832,0,0,1-1.207.877L12,19.632,5.78,22.9a.833.833,0,0,1-1.207-.878L5.761,15.1l-5.033-4.9a.831.831,0,0,1,.461-1.418L8.143,7.765l3.11-6.3A.833.833,0,0,1,12.746,1.464Z",
                        fill: color
                    })
                })
            });
        case "integration":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12.414,16l2-2L13,12.586l-2,2L9.414,13l2-2L10,9.586l-2,2L6.671,10.258a1,1,0,0,0-1.414,0l-1.5,1.5a5.989,5.989,0,0,0-.644,7.715l-2.82,2.82a1,1,0,1,0,1.414,1.414l2.82-2.82a5.989,5.989,0,0,0,7.716-.645l1.5-1.5a1,1,0,0,0,0-1.414Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M17.329,13.742a1,1,0,0,0,1.414,0l1.5-1.5a5.989,5.989,0,0,0,.644-7.715l2.82-2.82A1,1,0,1,0,22.293.293l-2.82,2.82a5.989,5.989,0,0,0-7.716.645l-1.5,1.5a1,1,0,0,0,0,1.414Z",
                            "data-color": "color-2"
                        })
                    ]
                })
            });
        case "list":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            cx: "3",
                            cy: "6",
                            r: "3",
                            "data-color": "color-2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            cx: "3",
                            cy: "16",
                            r: "3",
                            "data-color": "color-2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M10,6h13c.552,0,1-.448,1-1s-.448-1-1-1H10c-.552,0-1,.448-1,1s.448,1,1,1Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M23,11H10c-.552,0-1,.448-1,1s.448,1,1,1h13c.552,0,1-.448,1-1s-.448-1-1-1Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M23,18H10c-.552,0-1,.448-1,1s.448,1,1,1h13c.552,0,1-.448,1-1s-.448-1-1-1Z",
                            fill: color
                        })
                    ]
                })
            });
        case "enter":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M13,1H3A1,1,0,0,0,3,3H13V9H4.414L6.707,6.707A1,1,0,0,0,5.293,5.293l-4,4a1,1,0,0,0,0,1.414l4,4a1,1,0,1,0,1.414-1.414L4.414,11H13a2,2,0,0,0,2-2V3A2,2,0,0,0,13,1Z",
                        fill: color
                    })
                })
            });
        case "timer":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M21,2H3c-.553,0-1-.447-1-1s.447-1,1-1H21c.553,0,1,.447,1,1s-.447,1-1,1Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M21,24H3c-.553,0-1-.447-1-1s.447-1,1-1H21c.553,0,1,.447,1,1s-.447,1-1,1Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M19,6v-2H5v2c0,2.499,2.131,4.813,3.441,6-1.311,1.187-3.441,3.501-3.441,6v2h14v-2c0-2.499-2.131-4.813-3.441-6,1.311-1.187,3.441-3.501,3.441-6Z",
                            fill: color
                        })
                    ]
                })
            });
        case "bag":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M19.694,24H4.306a3,3,0,0,1-2.97-3.425L3.01,8.858A1,1,0,0,1,4,8H20a1,1,0,0,1,.99.858l1.674,11.717A3,3,0,0,1,19.694,24Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M9,6V5a3,3,0,1,1,6,0V6h2V5A5,5,0,0,0,7,5V6Z"
                        })
                    ]
                })
            });
        case "revenue-cat":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                className: className,
                viewBox: "0 0 25 25",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M2 3.3623C3.04502 3.10613 4.66292 2.95837 6.12372 2.95837C10.0714 2.95837 12.4352 4.35243 12.4352 7.90074C12.4352 10.0764 11.5675 11.512 10.2065 12.2932L13.5 17.9958C13.2439 18.1833 12.6913 18.2917 11.9208 18.2917C11.0531 18.2917 10.4811 18.1864 10.0671 17.9958L7.3254 13.0534H7.00948C6.32971 13.0537 5.6508 13.0045 4.97798 12.9061V18.0172C4.70166 18.1863 4.20841 18.2917 3.49868 18.2917C2.80917 18.2917 2.29569 18.1855 2 18.0172V3.3623ZM4.94096 10.2233C5.50135 10.3225 6.06862 10.3719 6.63675 10.3711C8.35278 10.3711 9.39867 9.71316 9.39867 8.06949C9.39867 6.37861 8.29381 5.6831 6.3217 5.6831C5.85862 5.68101 5.39637 5.72287 4.94096 5.80813V10.2233Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M25 18.2818C25 20.7499 23.732 21.428 22.7778 21.8837C20.3413 23.0489 16.4379 21.6936 12.2892 21.2813C8.53257 20.7967 4.80695 20.4774 4.22805 21.3085C4.01027 21.5189 3.96421 22.197 4.22805 22.4733C5.00709 23.289 7.03819 22.7202 8.47661 22.4635C8.69452 22.4288 8.91781 22.45 9.12502 22.5251C9.33223 22.6002 9.51639 22.7267 9.65981 22.8924C9.94604 23.2274 10.0235 23.6827 9.86296 24.0869C9.70285 24.4912 9.32925 24.7828 8.88292 24.8521C8.23257 24.9499 7.57534 24.9992 6.91725 25C5.51627 25 3.7546 24.7616 2.75476 23.712C2.25678 23.1904 1.74675 22.2637 2.13971 20.8137C2.88776 18.0659 7.36573 18.7447 12.553 19.2604C16.165 19.6192 20.0834 20.8137 21.6488 19.7169C22.0478 19.4372 22.7924 18.8106 22.3913 18.2818C21.9897 17.7526 21.3329 18.0395 20.47 18.0395C16.1474 18.0395 13.6015 15.2921 13.6015 10.7083C13.6024 7.26418 15.0455 4.85601 17.3977 3.71292C18.4199 3.21641 19.6139 2.95837 20.9352 2.95837C22.0874 2.95837 23.2581 3.15775 24.0058 3.5956C24.4702 4.25322 24.6725 5.42818 24.5709 6.30558C23.6012 5.84732 22.7128 5.608 21.5615 5.608C18.7134 5.608 16.7538 7.04312 16.7538 10.5089C16.7538 13.9747 18.6928 15.3499 21.4199 15.3499C22.1959 15.3423 23.2465 15.2492 24.5709 15.0711C24.8571 16.1219 25 17.1919 25 18.2818Z",
                        fill: color
                    })
                ]
            });
        case "cloud":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M13.1,13c1.6,0,2.9-1.3,2.9-2.9c0-1.6-1.3-2.9-2.9-2.9c0,0,0,0,0,0C12.9,4.3,10.5,2,7.6,2 C4.7,2,2.3,4.3,2.2,7.2C0.9,7.6,0,8.7,0,10.1C0,11.7,1.3,13,2.9,13H13.1z"
                    })
                })
            });
        case "logo-color":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                className: className,
                viewBox: "0 0 46 43",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                        width: "46",
                        height: "43"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M10.9399 36.7987C11.1706 36.7987 11.354 36.7316 11.4903 36.5975C11.6267 36.4634 11.6948 36.2828 11.6948 36.0559V33.8893C13.9176 33.6623 15.6844 32.9917 16.995 31.8774C18.3057 30.7632 18.961 29.3084 18.961 27.5133C18.961 26.2958 18.6989 25.2951 18.1746 24.511C17.6503 23.7269 16.8377 23.0769 15.7368 22.561C14.6359 22.0452 13.1522 21.5809 11.2859 21.1682C9.94379 20.8381 8.91101 20.5285 8.18754 20.2397C7.46407 19.9508 6.93981 19.6206 6.61477 19.2492C6.28974 18.8778 6.12722 18.4135 6.12722 17.8564C6.12722 17.031 6.4575 16.4017 7.11806 15.9684C7.77862 15.535 8.68558 15.3184 9.83894 15.3184C10.8875 15.3184 11.763 15.5402 12.4655 15.9838C13.168 16.4275 13.5821 16.9794 13.7079 17.6397C13.8757 18.0112 14.1798 18.1969 14.6201 18.1969H17.6084C17.7971 18.1969 17.9544 18.135 18.0802 18.0112C18.2061 17.8874 18.269 17.7326 18.269 17.5469C18.227 16.7834 17.9492 15.9993 17.4354 15.1946C16.9216 14.3898 16.1772 13.6831 15.2021 13.0744C14.227 12.4657 13.0579 12.0685 11.6948 11.8828V9.68522C11.6948 9.45824 11.6267 9.27769 11.4903 9.14357C11.354 9.00944 11.1706 8.94238 10.9399 8.94238H8.98965C8.77995 8.94238 8.6017 9.00944 8.45491 9.14357C8.30812 9.27769 8.23472 9.45824 8.23472 9.68522V11.8209C6.17964 12.0685 4.55969 12.7494 3.37488 13.8637C2.19006 14.9779 1.59765 16.3398 1.59765 17.9493C1.59765 19.7238 2.17433 21.0857 3.32769 22.0348C4.48105 22.984 6.29498 23.7475 8.76946 24.3253C10.2583 24.7173 11.3855 25.0526 12.1509 25.3312C12.9163 25.6097 13.4878 25.9347 13.8652 26.3061C14.2427 26.6776 14.4314 27.1418 14.4314 27.699C14.4314 28.545 14.0592 29.2104 13.3148 29.6953C12.5703 30.1802 11.4746 30.4227 10.0277 30.4227C8.72752 30.4227 7.70522 30.1854 6.96078 29.7108C6.21634 29.2362 5.72878 28.6481 5.49811 27.9466C5.37229 27.7402 5.24122 27.5906 5.10492 27.4978C4.96861 27.4049 4.77464 27.3585 4.52299 27.3585H1.69202C1.50328 27.3585 1.34077 27.4256 1.20446 27.5597C1.06815 27.6938 1 27.8434 1 28.0085C1.04194 28.9577 1.34077 29.8501 1.89648 30.6858C2.45219 31.5215 3.27003 32.2282 4.34999 32.806C5.42996 33.3837 6.72487 33.7448 8.23472 33.8893V36.0559C8.23472 36.2828 8.30812 36.4634 8.45491 36.5975C8.6017 36.7316 8.77995 36.7987 8.98965 36.7987H10.9399Z",
                        fill: "#74FFF1",
                        stroke: "#74FFF1",
                        strokeWidth: "0.5"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M28.7343 29.666C29.3005 29.666 29.6674 29.4081 29.8352 28.8922L33.3582 18.6163L36.8812 28.8922C36.9441 29.0986 37.0699 29.2791 37.2586 29.4339C37.4474 29.5886 37.6885 29.666 37.9821 29.666H40.1211C40.4356 29.666 40.6925 29.5835 40.8917 29.4184C41.091 29.2533 41.2115 29.0264 41.2535 28.7375L44.9652 8.89759C44.9862 8.83569 44.9967 8.75315 44.9967 8.64998C44.9967 8.46427 44.9337 8.30951 44.8079 8.18571C44.6821 8.0619 44.5353 8 44.3676 8H41.5366C41.0123 8 40.7187 8.20634 40.6558 8.61903L38.0765 22.5472L35.2455 13.5713C35.1826 13.3649 35.0673 13.1844 34.8995 13.0296C34.7317 12.8749 34.5116 12.7975 34.2389 12.7975H32.5089C32.0266 12.7975 31.6806 13.0554 31.4709 13.5713L28.6713 22.5472L26.0606 8.61903C26.0186 8.39205 25.9347 8.23214 25.8089 8.13928C25.6831 8.04643 25.4839 8 25.2113 8H22.3803C22.1916 8 22.0343 8.0619 21.9085 8.18571C21.7826 8.30951 21.7197 8.46427 21.7197 8.64998L21.7512 8.89759L25.4629 28.7375C25.6097 29.3565 25.9872 29.666 26.5953 29.666H28.7343Z",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: "0.5"
                    })
                ]
            });
        case "logo":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                className: className,
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M11.6704 5C11.5073 5 11.3555 5.05276 11.2344 5.16513C11.1125 5.27817 11.0514 5.42445 11.0514 5.5855V5.60232L11.0714 5.75125L13.0539 15.7426L13.0555 15.7488C13.1046 15.9442 13.1995 16.1174 13.358 16.24C13.5171 16.3629 13.712 16.4131 13.9185 16.4131H15.0594C15.2494 16.4131 15.4302 16.3721 15.5831 16.2707C15.737 16.1688 15.8391 16.0214 15.8987 15.8496L17.5257 11.3752L19.1519 15.8475C19.2041 16.0053 19.3053 16.1359 19.4399 16.24C19.5973 16.3617 19.7885 16.4131 19.992 16.4131H21.1328C21.3471 16.4131 21.5474 16.3593 21.7112 16.2314C21.8739 16.1042 21.9677 15.9309 21.9997 15.7315L23.9755 5.77354C23.9947 5.71046 24 5.64489 24 5.5855C24 5.42445 23.9388 5.27817 23.817 5.16513C23.7024 5.05877 23.5588 5 23.3978 5H21.8878C21.7184 5 21.5493 5.03077 21.4102 5.12292C21.2637 5.21999 21.1825 5.36387 21.1554 5.52524L19.975 11.5351L18.7868 7.98302L18.7863 7.98162C18.7373 7.83092 18.6479 7.70169 18.5258 7.59548C18.3776 7.46658 18.1921 7.41265 17.9954 7.41265H17.0727C16.8954 7.41265 16.7284 7.45826 16.5848 7.55915C16.4435 7.65853 16.3428 7.79888 16.273 7.96065L16.2686 7.97086L15.0903 11.5328L13.8952 5.52132C13.8658 5.37127 13.7979 5.21826 13.6545 5.11853C13.519 5.02423 13.344 5 13.1803 5H11.6704Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M4.52814 5.4738C4.35584 5.4738 4.19642 5.52773 4.06582 5.64024C3.92315 5.76316 3.85881 5.92813 3.85881 6.10599V6.95366C2.83079 7.10357 1.98923 7.45269 1.35342 8.01647C0.66785 8.62437 0.318771 9.37785 0.318771 10.262C0.318771 11.2182 0.652159 11.9836 1.3416 12.5186C2.00264 13.0315 3.01511 13.4261 4.3481 13.7199C5.13825 13.9161 5.72908 14.0822 6.12532 14.2182C6.51567 14.3521 6.78117 14.5002 6.94431 14.6516C7.0909 14.7876 7.16397 14.9526 7.16397 15.1651C7.16397 15.4946 7.01884 15.7501 6.69237 15.9506C6.3573 16.1564 5.83223 16.2763 5.08179 16.2763C4.41547 16.2763 3.92563 16.1609 3.58647 15.9571C3.23024 15.7429 3.01761 15.4911 2.91845 15.2068L2.90841 15.178L2.89175 15.1522C2.8128 15.0302 2.71863 14.9224 2.60337 14.8483C2.46934 14.7622 2.30612 14.7353 2.14574 14.7353H0.63577C0.466468 14.7353 0.313742 14.7947 0.191383 14.9082C0.0761004 15.0152 0 15.1548 0 15.3208V15.3266L0.000274989 15.3325C0.0250464 15.8611 0.202228 16.3559 0.524719 16.8132C0.851098 17.276 1.32453 17.6573 1.93042 17.9629C2.48333 18.2418 3.12778 18.4225 3.85881 18.5103V19.3678C3.85881 19.5457 3.92315 19.7106 4.06582 19.8336C4.19642 19.9461 4.35584 20 4.52814 20H5.56834C5.74388 20 5.91338 19.9504 6.04628 19.8271C6.18054 19.7025 6.23767 19.5395 6.23767 19.3678V18.5091C7.35069 18.3703 8.26679 18.0278 8.96789 17.4658C9.73008 16.8548 10.1133 16.0493 10.1133 15.0717C10.1133 14.4217 9.96461 13.8634 9.64687 13.4153C9.33263 12.9722 8.85545 12.6189 8.23745 12.3459C7.62637 12.0759 6.81535 11.8379 5.81195 11.6286C5.1018 11.4638 4.56552 11.3115 4.19682 11.1727C3.82908 11.0343 3.59323 10.8866 3.45964 10.7427C3.33552 10.609 3.26806 10.4395 3.26806 10.2153C3.26806 9.88594 3.39996 9.65288 3.67327 9.48384C3.96705 9.30214 4.39419 9.19754 4.98113 9.19754C5.50435 9.19754 5.91981 9.30181 6.24252 9.49397C6.57133 9.68975 6.73384 9.91251 6.78307 10.1561L6.78929 10.1869L6.80291 10.2153C6.86734 10.3498 6.96436 10.4623 7.09735 10.5388C7.22863 10.6144 7.3776 10.6451 7.5313 10.6451H9.12516C9.28819 10.6451 9.44004 10.5924 9.56116 10.48C9.683 10.367 9.74415 10.2207 9.74415 10.0596V10.0523L9.74373 10.045C9.71811 9.60534 9.54899 9.16771 9.25578 8.73469C8.95575 8.29159 8.52676 7.91112 7.98004 7.58932C7.48027 7.29517 6.8978 7.09649 6.23767 6.98853V6.10599C6.23767 5.93429 6.18054 5.77128 6.04628 5.64671C5.91338 5.52341 5.74388 5.4738 5.56834 5.4738H4.52814Z",
                        fill: color
                    })
                ]
            });
        case "search":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M7,14c-3.86,0-7-3.14-7-7s3.14-7,7-7s7,3.14,7,7S10.86,14,7,14z M7,2C4.243,2,2,4.243,2,7s2.243,5,5,5 s5-2.243,5-5S9.757,2,7,2z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M15.707,14.293L13.314,11.9c-0.411,0.529-0.885,1.003-1.414,1.414l2.393,2.393 C14.488,15.902,14.744,16,15,16s0.512-0.098,0.707-0.293C16.098,15.316,16.098,14.684,15.707,14.293z"
                        }),
                        " "
                    ]
                })
            });
        case "checkout":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "6.5",
                            cy: "21.5",
                            r: "2.5"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "19.5",
                            cy: "21.5",
                            r: "2.5"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M20,17H6c-.501,0-.925-.371-.991-.868L3.125,2H1c-.552,0-1-.448-1-1H0C0,.448,.448,0,1,0h3c.501,0,.925,.371,.991,.868l.551,4.132H23c.316,0,.614,.149,.802,.403,.189,.254,.247,.582,.156,.884l-3,10c-.127,.423-.516,.713-.958,.713Z",
                            fill: color
                        })
                    ]
                })
            });
        case "dollar-sign":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M13,10.265V5.013a9.722,9.722,0,0,1,2.6.722l1.342.662,1.327-2.69-1.345-.663A12.4,12.4,0,0,0,13,1.989V0H11V1.983c-3.537.306-5.773,2.3-5.773,5.264,0,3.726,3.174,4.85,5.773,5.577V18.09a15.77,15.77,0,0,1-4.24-.819l-1.411-.509L4.33,19.583l1.411.51A18.577,18.577,0,0,0,11,21.1V24h2V21.087c5.125-.431,5.708-3.776,5.708-5.264C18.708,12.129,15.587,10.993,13,10.265ZM8.227,7.247c0-1.6,1.6-2.1,2.773-2.249V9.69C9.1,9.092,8.227,8.523,8.227,7.247ZM13,18.072V13.4c1.857.591,2.708,1.161,2.708,2.422C15.708,16.382,15.7,17.769,13,18.072Z",
                        fill: color
                    })
                })
            });
        case "cancel":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M20.5,3.5C20.5,3.5,20.5,3.5,20.5,3.5C18.3,1.3,15.3,0,12,0C5.4,0,0,5.4,0,12c0,3.3,1.3,6.3,3.5,8.5 c0,0,0,0,0,0s0,0,0,0C5.7,22.7,8.7,24,12,24c6.6,0,12-5.4,12-12C24,8.7,22.7,5.7,20.5,3.5C20.5,3.5,20.5,3.5,20.5,3.5z M12,2 c2.4,0,4.6,0.8,6.3,2.3L4.3,18.3C2.8,16.6,2,14.4,2,12C2,6.5,6.5,2,12,2z M12,22c-2.4,0-4.6-0.8-6.3-2.3L19.7,5.7 C21.2,7.4,22,9.6,22,12C22,17.5,17.5,22,12,22z"
                    })
                })
            });
        case "no-match":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M23.444,10.239a22.936,22.936,0,0,0-2.492-2.948l-4.021,4.021A5.026,5.026,0,0,1,17,12a5,5,0,0,1-5,5,5.026,5.026,0,0,1-.688-.069L8.055,20.188A10.286,10.286,0,0,0,12,21c5.708,0,9.905-5.062,11.445-7.24A3.058,3.058,0,0,0,23.444,10.239Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12,3C6.292,3,2.1,8.062.555,10.24a3.058,3.058,0,0,0,0,3.52h0a21.272,21.272,0,0,0,4.784,4.9l3.124-3.124a5,5,0,0,1,7.071-7.072L8.464,15.536l10.2-10.2A11.484,11.484,0,0,0,12,3Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M1,24a1,1,0,0,1-.707-1.707l22-22a1,1,0,0,1,1.414,1.414l-22,22A1,1,0,0,1,1,24Z"
                        })
                    ]
                })
            });
        case "paywall-open":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    })
                })
            });
        case "paywall-close":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M17,15H13V7a1,1,0,0,0-2,0v8H7a1,1,0,0,0-.769,1.641l5,6a1,1,0,0,0,1.538,0l5-6A1,1,0,0,0,17,15Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M22,1H2A1,1,0,0,0,2,3H22a1,1,0,0,0,0-2Z"
                        })
                    ]
                })
            });
        case "session":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12,5c1.381,0,2.5,1.119,2.5,2.5s-1.119,2.5-2.5,2.5-2.5-1.119-2.5-2.5,1.119-2.5,2.5-2.5Zm3.868,12h-7.736c-.653,0-1.137-.619-.974-1.251,.555-2.156,2.513-3.749,4.842-3.749s4.287,1.593,4.842,3.749c.163,.633-.321,1.251-.974,1.251Z",
                            "data-color": "color-2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M18,24H6c-1.654,0-3-1.346-3-3V3c0-1.654,1.346-3,3-3h12c1.654,0,3,1.346,3,3V21c0,1.654-1.346,3-3,3ZM6,2c-.551,0-1,.449-1,1V20c0,.551,.449,1,1,1h12c.551,0,1-.449,1-1V3c0-.551-.449-1-1-1H6Z",
                            fill: color
                        })
                    ]
                })
            });
        case "paywall":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M18,0H6C4.346,0,3,1.346,3,3v18c0,1.654,1.346,3,3,3h12c1.654,0,3-1.346,3-3V3C21,1.346,19.654,0,18,0z M19,20c0,0.552-0.448,1-1,1H6c-0.552,0-1-0.448-1-1V4c0-0.552,0.448-1,1-1h12c0.552,0,1,0.448,1,1V20z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            "data-color": "color-2",
                            x: "7",
                            y: "15",
                            width: "10",
                            height: "4"
                        })
                    ]
                })
            });
        case "up":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8.781.375a1.036,1.036,0,0,0-1.562,0l-4,5A1,1,0,0,0,4,7H7v8a1,1,0,0,0,2,0V7h3a1,1,0,0,0,.781-1.625Z",
                        fill: color
                    })
                })
            });
        case "check":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M6,15a1,1,0,0,1-.707-.293l-5-5A1,1,0,1,1,1.707,8.293L5.86,12.445,14.178.431a1,1,0,1,1,1.644,1.138l-9,13A1,1,0,0,1,6.09,15C6.06,15,6.03,15,6,15Z",
                        fill: color
                    })
                })
            });
        case "user":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M23.664,20.576l-.674-4.717c-.047-.325-.25-.606-.543-.753l-4.212-2.106c-1.467,1.827-3.716,3-6.235,3s-4.768-1.174-6.235-3L1.553,15.105c-.293,.147-.496,.428-.543,.753l-.674,4.718c-.123,.861,.134,1.732,.704,2.39s1.396,1.034,2.266,1.034H20.694c.87,0,1.695-.377,2.266-1.034s.827-1.528,.704-2.39Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12,0c-3.309,0-6,2.691-6,6v2c0,3.309,2.691,6,6,6s6-2.691,6-6v-2c0-3.309-2.691-6-6-6Z",
                            "data-color": "color-2"
                        })
                    ]
                })
            });
        case "calendar":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: "0 0 24 23",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M19 1C19 0.448 18.552 0 18 0C17.448 0 17 0.448 17 1V3H19V1Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M7 1C7 0.448 6.552 0 6 0C5.448 0 5 0.448 5 1V3H7V1Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M21 4H3C1.343 4 0 5.343 0 7V20C0 21.657 1.343 23 3 23H21C22.657 23 24 21.657 24 20V7C24 5.343 22.657 4 21 4ZM22 20C22 20.552 21.552 21 21 21H3C2.448 21 2 20.552 2 20V9H22V20Z",
                        fill: color
                    })
                ]
            });
        case "x":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3 c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z"
                    })
                })
            });
        case "chevron-down":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8,12a1,1,0,0,1-.707-.293l-6-6A1,1,0,0,1,2.707,4.293L8,9.586l5.293-5.293a1,1,0,1,1,1.414,1.414l-6,6A1,1,0,0,1,8,12Z",
                        fill: color
                    })
                })
            });
        case "info":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M8,0a8,8,0,1,0,8,8A8.024,8.024,0,0,0,8,0ZM8,14a6,6,0,1,1,6-6A6.018,6.018,0,0,1,8,14Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            "data-color": "color-2",
                            x: "7",
                            y: "7",
                            width: "2",
                            height: "5",
                            rx: "0.5"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "8",
                            cy: "5",
                            r: "1"
                        })
                    ]
                })
            });
        case "bolt-off":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                        clipPath: "url(#clip0_1706_18)",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M18.4251 15.036L21.8285 10.6116C22.0605 10.3096 22.1005 9.90164 21.9325 9.55964C21.7645 9.21764 21.4165 9.00164 21.0355 9.00164H13.1525L14.0285 1.11164C14.0785 0.665638 13.8245 0.241638 13.4085 0.073638C12.9915 -0.096362 12.5145 0.0356381 12.2415 0.390638L8.56242 5.17338L18.4251 15.036ZM5.45841 9.2086L2.24146 13.3906C2.00946 13.6926 1.96846 14.1006 2.13746 14.4426C2.30646 14.7856 2.65446 15.0016 3.03546 15.0016H10.9185L10.0425 22.8916C9.99246 23.3376 10.2465 23.7616 10.6625 23.9296C10.7835 23.9786 10.9105 24.0016 11.0355 24.0016C11.3395 24.0016 11.6355 23.8626 11.8285 23.6116L15.3211 19.0713L5.45841 9.2086Z",
                                fill: color
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                d: "M22.3608 20.8615C22.8245 21.3251 22.8245 22.0769 22.3608 22.5405C21.8972 23.0042 21.1454 23.0042 20.6818 22.5405L1.70029 3.55905C1.23662 3.09539 1.23662 2.34364 1.70029 1.87998C2.16395 1.41631 2.9157 1.41631 3.37937 1.87998L22.3608 20.8615Z",
                                fill: color
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("defs", {
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("clipPath", {
                            id: "clip0_1706_18",
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                                width: "24",
                                height: "24",
                                fill: "white"
                            })
                        })
                    })
                ]
            });
        case "bolt":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fill: color,
                        d: "M21.897,9.558C21.729,9.216,21.381,9,21,9h-7.883l0.876-7.89c0.05-0.446-0.204-0.87-0.62-1.038 c-0.417-0.17-0.894-0.038-1.167,0.317l-10,13c-0.232,0.302-0.273,0.71-0.104,1.052C2.271,14.784,2.619,15,3,15h7.883l-0.876,7.89 c-0.05,0.446,0.204,0.87,0.62,1.038C10.748,23.977,10.875,24,11,24c0.304,0,0.6-0.139,0.793-0.39l10-13 C22.025,10.308,22.065,9.9,21.897,9.558z"
                    })
                })
            });
        case "user-properties":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M21,2h-1c-.552,0-1,.448-1,1,0,1.103-.897,2-2,2s-2-.897-2-2c0-.552-.448-1-1-1h-4c-.552,0-1,.448-1,1,0,1.103-.897,2-2,2s-2-.897-2-2c0-.552-.448-1-1-1h-1C1.346,2,0,3.346,0,5v14c0,1.654,1.346,3,3,3H21c1.654,0,3-1.346,3-3V5c0-1.654-1.346-3-3-3Zm-9,14.5c0,.276-.224,.5-.5,.5H4.5c-.276,0-.5-.224-.5-.5v-7c0-.276,.224-.5,.5-.5h7c.276,0,.5,.224,.5,.5v7Zm8-1c0,.276-.224,.5-.5,.5h-5c-.276,0-.5-.224-.5-.5v-1c0-.276,.224-.5,.5-.5h5c.276,0,.5,.224,.5,.5v1Zm0-4c0,.276-.224,.5-.5,.5h-5c-.276,0-.5-.224-.5-.5v-1c0-.276,.224-.5,.5-.5h5c.276,0,.5,.224,.5,.5v1Z",
                        fill: color
                    })
                })
            });
        case "device":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M18,0H6A3,3,0,0,0,3,3V21a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V3A3,3,0,0,0,18,0Zm1,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V4A1,1,0,0,1,6,3H18a1,1,0,0,1,1,1Z",
                        fill: color
                    })
                })
            });
        case "purchasers":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M12.551,14.523v1.945c0.708-0.12,1.062-0.427,1.062-0.922C13.613,15.019,13.033,14.744,12.551,14.523z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M10.473,10.805c0,0.552,0.499,0.799,1.008,1.023V9.992C10.809,10.091,10.473,10.362,10.473,10.805z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M18,3l-3-3l-3,3L9,0L6,3L2,0v23c0,0.553,0.448,1,1,1h18c0.552,0,1-0.447,1-1V0L18,3z M12.551,18.328v1.602 h-1.07v-1.57c-1.271-0.026-2.386-0.25-3.344-0.672v-2.062c0.9,0.445,2.328,0.835,3.344,0.898v-2.422 c-1.789-0.694-3.359-1.367-3.359-3.297c0-1.753,1.608-2.577,3.359-2.75V6.859h1.07v1.164c1.192,0.052,2.271,0.292,3.234,0.719 l-0.734,1.828c-0.812-0.333-1.646-0.536-2.5-0.609v2.305c1.898,0.73,3.414,1.395,3.414,3.164 C15.965,17.295,14.416,18.157,12.551,18.328z"
                        })
                    ]
                })
            });
        case "users":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: `mb-[1px] ${className}`,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M23.371,14.749l-3.742-1.5A1,1,0,0,1,19,12.323v-.878A3.982,3.982,0,0,0,21,8V6.172a4.116,4.116,0,0,0-3.607-4.153A4,4,0,0,0,13,6V8a3.982,3.982,0,0,0,2,3.445v.878a4.737,4.737,0,0,1-1.6,2.065c-.068.044-.134.093-.2.138l.911.365A2.988,2.988,0,0,1,16,17.677V20a2.966,2.966,0,0,1-.184,1H23a1,1,0,0,0,1-1V15.677A1,1,0,0,0,23.371,14.749Z",
                            "data-color": "color-2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M13.371,16.749l-3.742-1.5A1,1,0,0,1,9,14.323v-.451a7.18,7.18,0,0,0,3.248-1.115.988.988,0,0,0,.181-1.416A5.991,5.991,0,0,1,11,8.038a3.879,3.879,0,0,0-1.9-3.5A4.046,4.046,0,0,0,3,8a5.943,5.943,0,0,1-1.429,3.342.987.987,0,0,0,.181,1.415A7.18,7.18,0,0,0,5,13.872v.451a1,1,0,0,1-.629.928l-3.742,1.5A1,1,0,0,0,0,17.677V20a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V17.677A1,1,0,0,0,13.371,16.749Z",
                            fill: color
                        })
                    ]
                })
            });
        case "refresh":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M14.413.389a.5.5,0,0,0-.849-.235L12.076,1.713a7.494,7.494,0,1,0,3.062,8.595,1,1,0,0,0-1.9-.616,5.513,5.513,0,1,1-2.573-6.5l-1.6,1.68a.5.5,0,0,0,.269.837L15.158,6.8a.478.478,0,0,0,.092.009.5.5,0,0,0,.487-.612Z",
                        fill: color
                    })
                })
            });
        case "spinner":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,2a6,6,0,1,0,6,6A6.006,6.006,0,0,0,8,2Z",
                            fill: color,
                            opacity: "0.4"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M16,8H14A6.006,6.006,0,0,0,8,2V0A8.009,8.009,0,0,1,16,8Z",
                            "data-color": "color-2"
                        })
                    ]
                })
            });
        case "debug":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M22,1H2A1,1,0,0,0,1,2V22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V2A1,1,0,0,0,22,1ZM4.586,17l5-5-5-5L6,5.586,12.414,12,6,18.414ZM19,18H12V16h7Zm0-5H14V11h5Zm0-5H12V6h7Z",
                        fill: color
                    })
                })
            });
        case "split":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M5,14a1,1,0,0,0,.833-.445L9.535,8H13v3a1,1,0,0,0,1.625.781l5-4a1,1,0,0,0,0-1.562l-5-4A1,1,0,0,0,13,3V6H9a1,1,0,0,0-.832.445l-4,6A1,1,0,0,0,5,14Z"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M18.625,12.219A1,1,0,0,0,17,13v3H1a1,1,0,0,0,0,2H17v3a1,1,0,0,0,1.625.781l5-4a1,1,0,0,0,0-1.562Z",
                            fill: color
                        })
                    ]
                })
            });
        case "chevron-right":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                    })
                })
            });
        case "logo-full":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 157 22",
                version: "1.1",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    id: "Design-Guidelines",
                    stroke: "none",
                    strokeWidth: "1",
                    fill: "none",
                    fillRule: "evenodd",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                        id: "Superwall-Design/Guidelines-Copy",
                        transform: "translate(-139.000000, -71.000000)",
                        fillRule: "nonzero",
                        strokeWidth: "0.5",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                            id: "Group",
                            transform: "translate(139.579010, 71.340393)",
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M7.268,20.7 C7.43666667,20.7 7.57083333,20.6501667 7.6705,20.5505 C7.77016667,20.4508333 7.82,20.3166667 7.82,20.148 L7.82,20.148 L7.82,18.538 C9.44533333,18.3693333 10.7371667,17.871 11.6955,17.043 C12.6538333,16.215 13.133,15.134 13.133,13.8 C13.133,12.8953333 12.9413333,12.1516667 12.558,11.569 C12.1746667,10.9863333 11.5805,10.5033333 10.7755,10.12 C9.9705,9.73666667 8.88566667,9.39166667 7.521,9.085 C6.53966667,8.83966667 5.7845,8.60966667 5.2555,8.395 C4.7265,8.18033333 4.34316667,7.935 4.1055,7.659 C3.86783333,7.383 3.749,7.038 3.749,6.624 C3.749,6.01066667 3.9905,5.543 4.4735,5.221 C4.9565,4.899 5.61966667,4.738 6.463,4.738 C7.22966667,4.738 7.86983333,4.90283333 8.3835,5.2325 C8.89716667,5.56216667 9.2,5.97233333 9.292,6.463 C9.41466667,6.739 9.637,6.877 9.959,6.877 L9.959,6.877 L12.144,6.877 C12.282,6.877 12.397,6.831 12.489,6.739 C12.581,6.647 12.627,6.532 12.627,6.394 C12.5963333,5.82666667 12.3931667,5.244 12.0175,4.646 C11.6418333,4.048 11.0975,3.52283333 10.3845,3.0705 C9.6715,2.61816667 8.81666667,2.323 7.82,2.185 L7.82,2.185 L7.82,0.552 C7.82,0.383333333 7.77016667,0.249166667 7.6705,0.1495 C7.57083333,0.0498333333 7.43666667,-3.55271368e-14 7.268,-3.55271368e-14 L7.268,-3.55271368e-14 L5.842,-3.55271368e-14 C5.68866667,-3.55271368e-14 5.55833333,0.0498333333 5.451,0.1495 C5.34366667,0.249166667 5.29,0.383333333 5.29,0.552 L5.29,0.552 L5.29,2.139 C3.78733333,2.323 2.60283333,2.829 1.7365,3.657 C0.870166667,4.485 0.437,5.497 0.437,6.693 C0.437,8.01166667 0.858666667,9.02366667 1.702,9.729 C2.54533333,10.4343333 3.87166667,11.0016667 5.681,11.431 C6.76966667,11.7223333 7.59383333,11.9715 8.1535,12.1785 C8.71316667,12.3855 9.131,12.627 9.407,12.903 C9.683,13.179 9.821,13.524 9.821,13.938 C9.821,14.5666667 9.54883333,15.0611667 9.0045,15.4215 C8.46016667,15.7818333 7.659,15.962 6.601,15.962 C5.65033333,15.962 4.90283333,15.7856667 4.3585,15.433 C3.81416667,15.0803333 3.45766667,14.6433333 3.289,14.122 C3.197,13.9686667 3.10116667,13.8575 3.0015,13.7885 C2.90183333,13.7195 2.76,13.685 2.576,13.685 L2.576,13.685 L0.506,13.685 C0.368,13.685 0.249166667,13.7348333 0.1495,13.8345 C0.0498333333,13.9341667 -1.42108547e-14,14.0453333 -1.42108547e-14,14.168 C0.0306666667,14.8733333 0.249166667,15.5365 0.6555,16.1575 C1.06183333,16.7785 1.65983333,17.3036667 2.4495,17.733 C3.23916667,18.1623333 4.186,18.4306667 5.29,18.538 L5.29,18.538 L5.29,20.148 C5.29,20.3166667 5.34366667,20.4508333 5.451,20.5505 C5.55833333,20.6501667 5.68866667,20.7 5.842,20.7 L5.842,20.7 L7.268,20.7 Z",
                                    id: "Path",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M24.718,18.63 C26.788,18.63 28.3941667,18.101 29.5365,17.043 C30.6788333,15.985 31.25,14.3826667 31.25,12.236 L31.25,12.236 L31.25,2.875 C31.25,2.70633333 31.2001667,2.56833333 31.1005,2.461 C31.0008333,2.35366667 30.8666667,2.3 30.698,2.3 L30.698,2.3 L28.582,2.3 C28.4133333,2.3 28.2753333,2.35366667 28.168,2.461 C28.0606667,2.56833333 28.007,2.70633333 28.007,2.875 L28.007,2.875 L28.007,12.236 C28.007,13.4473333 27.7195,14.3596667 27.1445,14.973 C26.5695,15.5863333 25.753,15.893 24.695,15.893 C23.637,15.893 22.8205,15.5863333 22.2455,14.973 C21.6705,14.3596667 21.383,13.4473333 21.383,12.236 L21.383,12.236 L21.383,2.875 C21.383,2.70633333 21.3293333,2.56833333 21.222,2.461 C21.1146667,2.35366667 20.9766667,2.3 20.808,2.3 L20.808,2.3 L18.692,2.3 C18.5233333,2.3 18.3891667,2.35366667 18.2895,2.461 C18.1898333,2.56833333 18.14,2.70633333 18.14,2.875 L18.14,2.875 L18.14,12.236 C18.14,14.3826667 18.715,15.985 19.865,17.043 C21.015,18.101 22.6326667,18.63 24.718,18.63 Z",
                                    id: "Path",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M43.916,2.3 L44.2592031,2.30512109 C45.9518594,2.35633203 47.294125,2.791625 48.286,3.611 C49.344,4.485 49.873,5.75766667 49.873,7.429 C49.873,9.085 49.344,10.3385 48.286,11.1895 C47.228,12.0405 45.7713333,12.466 43.916,12.466 L43.916,12.466 L40.535,12.466 L40.535,17.848 L40.52856,17.94506 C40.5113867,18.0689533 40.4598667,18.1707667 40.374,18.2505 C40.2666667,18.3501667 40.1286667,18.4 39.96,18.4 L39.96,18.4 L37.752,18.4 L37.66276,18.39356 C37.5474533,18.3763867 37.4468667,18.3248667 37.361,18.239 C37.2536667,18.1316667 37.2,18.0013333 37.2,17.848 L37.2,17.848 L37.2,2.875 L37.20598,2.77748 C37.2219267,2.65236 37.2697667,2.54686667 37.3495,2.461 C37.4491667,2.35366667 37.5833333,2.3 37.752,2.3 L37.752,2.3 L43.916,2.3 Z M43.801,4.876 L40.489,4.876 L40.489,9.89 L43.801,9.89 C44.6903333,9.89 45.3688333,9.67916667 45.8365,9.2575 C46.3041667,8.83583333 46.538,8.21866667 46.538,7.406 C46.538,6.60866667 46.3118333,5.98766667 45.8595,5.543 C45.4071667,5.09833333 44.721,4.876 43.801,4.876 L43.801,4.876 Z",
                                    id: "Combined-Shape",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M65.759,18.4 C65.9276667,18.4 66.0656667,18.3501667 66.173,18.2505 C66.2803333,18.1508333 66.334,18.0166667 66.334,17.848 L66.334,17.848 L66.334,16.284 C66.334,16.1153333 66.2803333,15.9811667 66.173,15.8815 C66.0656667,15.7818333 65.9276667,15.732 65.759,15.732 L65.759,15.732 L58.031,15.732 L58.031,11.569 L65.069,11.569 C65.2376667,11.569 65.3756667,11.5191667 65.483,11.4195 C65.5903333,11.3198333 65.644,11.1856667 65.644,11.017 L65.644,11.017 L65.644,9.568 C65.644,9.39933333 65.5903333,9.26133333 65.483,9.154 C65.3756667,9.04666667 65.2376667,8.993 65.069,8.993 L65.069,8.993 L58.031,8.993 L58.031,4.968 L65.575,4.968 C65.7436667,4.968 65.8816667,4.91816667 65.989,4.8185 C66.0963333,4.71883333 66.15,4.58466667 66.15,4.416 L66.15,4.416 L66.15,2.875 C66.15,2.70633333 66.0963333,2.56833333 65.989,2.461 C65.8816667,2.35366667 65.7436667,2.3 65.575,2.3 L65.575,2.3 L55.432,2.3 C55.2633333,2.3 55.1291667,2.35366667 55.0295,2.461 C54.9298333,2.56833333 54.88,2.70633333 54.88,2.875 L54.88,2.875 L54.88,17.848 C54.88,18.0013333 54.9336667,18.1316667 55.041,18.239 C55.1483333,18.3463333 55.2786667,18.4 55.432,18.4 L55.432,18.4 L65.759,18.4 Z",
                                    id: "Path",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M78.218,2.3 L78.5668184,2.30512109 C80.286877,2.35633203 81.6464375,2.791625 82.6455,3.611 C83.7111667,4.485 84.244,5.727 84.244,7.337 C84.244,8.45633333 83.9756667,9.3955 83.439,10.1545 C82.9023333,10.9135 82.151,11.4616667 81.185,11.799 L81.185,11.799 L84.52,17.664 L84.5583333,17.7534444 C84.5787778,17.8113704 84.589,17.8658889 84.589,17.917 C84.589,18.055 84.5391667,18.17 84.4395,18.262 C84.3398333,18.354 84.2286667,18.4 84.106,18.4 L84.106,18.4 L81.99,18.4 L81.84924,18.3931 C81.6701467,18.3747 81.5254,18.3195 81.415,18.2275 C81.277,18.1125 81.1543333,17.963 81.047,17.779 L81.047,17.779 L78.103,12.328 L74.952,12.328 L74.952,17.848 L74.94556,17.93724 C74.9283867,18.0525467 74.8768667,18.1531333 74.791,18.239 C74.6836667,18.3463333 74.5456667,18.4 74.377,18.4 L74.377,18.4 L72.261,18.4 L72.17176,18.39356 C72.0564533,18.3763867 71.9558667,18.3248667 71.87,18.239 C71.7626667,18.1316667 71.709,18.0013333 71.709,17.848 L71.709,17.848 L71.709,2.875 L71.71498,2.77748 C71.7309267,2.65236 71.7787667,2.54686667 71.8585,2.461 C71.9581667,2.35366667 72.0923333,2.3 72.261,2.3 L72.261,2.3 L78.218,2.3 Z M78.149,4.876 L74.952,4.876 L74.952,9.706 L78.149,9.706 C79.069,9.706 79.759,9.50283333 80.219,9.0965 C80.679,8.69016667 80.909,8.096 80.909,7.314 C80.909,6.532 80.679,5.93016667 80.219,5.5085 C79.759,5.08683333 79.069,4.876 78.149,4.876 L78.149,4.876 Z",
                                    id: "Combined-Shape",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M93.713,18.4 C94.127,18.4 94.3953333,18.2083333 94.518,17.825 L94.518,17.825 L97.094,10.189 L99.67,17.825 C99.716,17.9783333 99.808,18.1125 99.946,18.2275 C100.084,18.3425 100.260333,18.4 100.475,18.4 L100.475,18.4 L102.039,18.4 C102.269,18.4 102.456833,18.3386667 102.6025,18.216 C102.748167,18.0933333 102.836333,17.9246667 102.867,17.71 L102.867,17.71 L105.581,2.967 C105.596333,2.921 105.604,2.85966667 105.604,2.783 C105.604,2.645 105.558,2.53 105.466,2.438 C105.374,2.346 105.266667,2.3 105.144,2.3 L105.144,2.3 L103.074,2.3 C102.690667,2.3 102.476,2.45333333 102.43,2.76 L102.43,2.76 L100.544,13.11 L98.474,6.44 C98.428,6.28666667 98.3436667,6.1525 98.221,6.0375 C98.0983333,5.9225 97.9373333,5.865 97.738,5.865 L97.738,5.865 L96.473,5.865 C96.1203333,5.865 95.8673333,6.05666667 95.714,6.44 L95.714,6.44 L93.667,13.11 L91.758,2.76 C91.7273333,2.59133333 91.666,2.4725 91.574,2.4035 C91.482,2.3345 91.3363333,2.3 91.137,2.3 L91.137,2.3 L89.067,2.3 C88.929,2.3 88.814,2.346 88.722,2.438 C88.63,2.53 88.584,2.645 88.584,2.783 L88.584,2.783 L88.607,2.967 L91.321,17.71 C91.4283333,18.17 91.7043333,18.4 92.149,18.4 L92.149,18.4 L93.713,18.4 Z",
                                    id: "Path",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M117.58,2.3 L117.708346,2.30709877 C118.038486,2.34495885 118.271704,2.53425926 118.408,2.875 L118.408,2.875 L123.928,17.71 L123.974,17.917 L123.96802,17.99704 C123.952073,18.10008 123.904233,18.1884 123.8245,18.262 C123.724833,18.354 123.613667,18.4 123.491,18.4 L123.491,18.4 L121.444,18.4 L121.327922,18.3931719 C121.067974,18.3613073 120.884333,18.2179167 120.777,17.963 L120.777,17.963 L119.719,15.18 L112.911,15.18 L111.853,17.963 L111.802328,18.0654219 C111.673193,18.288474 111.46775,18.4 111.186,18.4 L111.186,18.4 L109.139,18.4 L109.039813,18.391375 C108.944938,18.374125 108.863,18.331 108.794,18.262 C108.702,18.17 108.656,18.055 108.656,17.917 L108.656,17.917 L108.702,17.71 L114.222,2.875 L114.277654,2.75432099 C114.438181,2.45144033 114.69563,2.3 115.05,2.3 L115.05,2.3 L117.58,2.3 Z M116.315,5.428 L113.716,12.512 L118.914,12.512 L116.315,5.428 Z",
                                    id: "Combined-Shape",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M139.147,18.4 C139.315667,18.4 139.453667,18.3463333 139.561,18.239 C139.668333,18.1316667 139.722,18.0013333 139.722,17.848 L139.722,17.848 L139.722,16.192 C139.722,16.0386667 139.668333,15.9083333 139.561,15.801 C139.453667,15.6936667 139.315667,15.64 139.147,15.64 L139.147,15.64 L131.856,15.64 L131.856,2.852 C131.856,2.68333333 131.806167,2.54916667 131.7065,2.4495 C131.606833,2.34983333 131.472667,2.3 131.304,2.3 L131.304,2.3 L129.142,2.3 C128.988667,2.3 128.858333,2.34983333 128.751,2.4495 C128.643667,2.54916667 128.59,2.68333333 128.59,2.852 L128.59,2.852 L128.59,17.848 C128.59,18.0013333 128.643667,18.1316667 128.751,18.239 C128.858333,18.3463333 128.988667,18.4 129.142,18.4 L129.142,18.4 L139.147,18.4 Z",
                                    id: "Path",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M155.01,18.4 C155.178667,18.4 155.316667,18.3463333 155.424,18.239 C155.531333,18.1316667 155.585,18.0013333 155.585,17.848 L155.585,17.848 L155.585,16.192 C155.585,16.0386667 155.531333,15.9083333 155.424,15.801 C155.316667,15.6936667 155.178667,15.64 155.01,15.64 L155.01,15.64 L147.719,15.64 L147.719,2.852 C147.719,2.68333333 147.669167,2.54916667 147.5695,2.4495 C147.469833,2.34983333 147.335667,2.3 147.167,2.3 L147.167,2.3 L145.005,2.3 C144.851667,2.3 144.721333,2.34983333 144.614,2.4495 C144.506667,2.54916667 144.453,2.68333333 144.453,2.852 L144.453,2.852 L144.453,17.848 C144.453,18.0013333 144.506667,18.1316667 144.614,18.239 C144.721333,18.3463333 144.851667,18.4 145.005,18.4 L145.005,18.4 L155.01,18.4 Z",
                                    id: "Path",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                })
                            ]
                        })
                    })
                })
            });
        default:
            return null;
    }
};
export { SIcon, SIcon_SIconType as SIconType };
